// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file pixel_tracker/v1/pixel_tracker.proto (package pixel_tracker.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ConversionType, ConversionTypeJson } from "../../bundles/v1/bundle_pb";
import { file_bundles_v1_bundle } from "../../bundles/v1/bundle_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { HttpBody, HttpBodyJson } from "../../google/api/httpbody_pb";
import { file_google_api_httpbody } from "../../google/api/httpbody_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file pixel_tracker/v1/pixel_tracker.proto.
 */
export const file_pixel_tracker_v1_pixel_tracker: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_bundles_v1_bundle, file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_api_httpbody, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message pixel_tracker.v1.Tag
 */
export type Tag = Message<"pixel_tracker.v1.Tag"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string display_name = 14;
	 */
	displayName: string;

	/**
	 * @generated from field: string description = 16;
	 */
	description: string;

	/**
	 * @generated from field: string namespace = 4;
	 */
	namespace: string;

	/**
	 * @generated from field: string collector_url = 5;
	 */
	collectorUrl: string;

	/**
	 * @generated from field: repeated string allowed_domains = 6;
	 */
	allowedDomains: string[];

	/**
	 * @generated from field: string id_query_param = 7;
	 */
	idQueryParam: string;

	/**
	 * @generated from field: pixel_tracker.v1.PixelConfiguration pixel_configuration = 8;
	 */
	pixelConfiguration?: PixelConfiguration;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerEvents default_tracker_events = 9;
	 */
	defaultTrackerEvents?: TrackerEvents;

	/**
	 * @generated from field: bool disable_default_trackers = 15;
	 */
	disableDefaultTrackers: boolean;

	/**
	 * @generated from field: string creator_id = 10;
	 */
	creatorId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 13;
	 */
	deletedAt?: Timestamp;
};

/**
 * @generated from message pixel_tracker.v1.Tag
 */
export type TagJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string display_name = 14;
	 */
	displayName?: string;

	/**
	 * @generated from field: string description = 16;
	 */
	description?: string;

	/**
	 * @generated from field: string namespace = 4;
	 */
	namespace?: string;

	/**
	 * @generated from field: string collector_url = 5;
	 */
	collectorUrl?: string;

	/**
	 * @generated from field: repeated string allowed_domains = 6;
	 */
	allowedDomains?: string[];

	/**
	 * @generated from field: string id_query_param = 7;
	 */
	idQueryParam?: string;

	/**
	 * @generated from field: pixel_tracker.v1.PixelConfiguration pixel_configuration = 8;
	 */
	pixelConfiguration?: PixelConfigurationJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerEvents default_tracker_events = 9;
	 */
	defaultTrackerEvents?: TrackerEventsJson;

	/**
	 * @generated from field: bool disable_default_trackers = 15;
	 */
	disableDefaultTrackers?: boolean;

	/**
	 * @generated from field: string creator_id = 10;
	 */
	creatorId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 13;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message pixel_tracker.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag, { jsonType: TagJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 0);

/**
 * @generated from message pixel_tracker.v1.TrackerEvents
 */
export type TrackerEvents = Message<"pixel_tracker.v1.TrackerEvents"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerEvent events = 1;
	 */
	events: TrackerEvent[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerEvents
 */
export type TrackerEventsJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerEvent events = 1;
	 */
	events?: TrackerEventJson[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerEvents.
 * Use `create(TrackerEventsSchema)` to create a new message.
 */
export const TrackerEventsSchema: GenMessage<TrackerEvents, { jsonType: TrackerEventsJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 1);

/**
 * @generated from message pixel_tracker.v1.Tracker
 */
export type Tracker = Message<"pixel_tracker.v1.Tracker"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 9;
	 */
	version: string;

	/**
	 * @generated from field: string tag_id = 2;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerEvents tracker_events = 4;
	 */
	trackerEvents?: TrackerEvents;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerOverrides tracker_overrides = 6;
	 */
	trackerOverrides?: TrackerOverrides;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;
};

/**
 * @generated from message pixel_tracker.v1.Tracker
 */
export type TrackerJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 9;
	 */
	version?: string;

	/**
	 * @generated from field: string tag_id = 2;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerEvents tracker_events = 4;
	 */
	trackerEvents?: TrackerEventsJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerOverrides tracker_overrides = 6;
	 */
	trackerOverrides?: TrackerOverridesJson;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;
};

/**
 * Describes the message pixel_tracker.v1.Tracker.
 * Use `create(TrackerSchema)` to create a new message.
 */
export const TrackerSchema: GenMessage<Tracker, { jsonType: TrackerJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 2);

/**
 * @generated from message pixel_tracker.v1.TrackerOverrides
 */
export type TrackerOverrides = Message<"pixel_tracker.v1.TrackerOverrides"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerOverride overrides = 1;
	 */
	overrides: TrackerOverride[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerOverrides
 */
export type TrackerOverridesJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerOverride overrides = 1;
	 */
	overrides?: TrackerOverrideJson[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerOverrides.
 * Use `create(TrackerOverridesSchema)` to create a new message.
 */
export const TrackerOverridesSchema: GenMessage<TrackerOverrides, { jsonType: TrackerOverridesJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 3);

/**
 * @generated from message pixel_tracker.v1.TrackerOverride
 */
export type TrackerOverride = Message<"pixel_tracker.v1.TrackerOverride"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType: TrackerEventType;

	/**
	 * @generated from field: bool is_conversion = 2;
	 */
	isConversion: boolean;
};

/**
 * @generated from message pixel_tracker.v1.TrackerOverride
 */
export type TrackerOverrideJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType?: TrackerEventTypeJson;

	/**
	 * @generated from field: bool is_conversion = 2;
	 */
	isConversion?: boolean;
};

/**
 * Describes the message pixel_tracker.v1.TrackerOverride.
 * Use `create(TrackerOverrideSchema)` to create a new message.
 */
export const TrackerOverrideSchema: GenMessage<TrackerOverride, { jsonType: TrackerOverrideJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 4);

/**
 * @generated from message pixel_tracker.v1.SuiteOverride
 */
export type SuiteOverride = Message<"pixel_tracker.v1.SuiteOverride"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteTrackerOverrides tracker_overrides = 5;
	 */
	trackerOverrides?: SuiteTrackerOverrides;

	/**
	 * @generated from field: string creator_id = 6;
	 */
	creatorId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp;
};

/**
 * @generated from message pixel_tracker.v1.SuiteOverride
 */
export type SuiteOverrideJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteTrackerOverrides tracker_overrides = 5;
	 */
	trackerOverrides?: SuiteTrackerOverridesJson;

	/**
	 * @generated from field: string creator_id = 6;
	 */
	creatorId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message pixel_tracker.v1.SuiteOverride.
 * Use `create(SuiteOverrideSchema)` to create a new message.
 */
export const SuiteOverrideSchema: GenMessage<SuiteOverride, { jsonType: SuiteOverrideJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 5);

/**
 * @generated from message pixel_tracker.v1.SuiteTrackerOverrides
 */
export type SuiteTrackerOverrides = Message<"pixel_tracker.v1.SuiteTrackerOverrides"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.SuiteTrackerOverride overrides = 1;
	 */
	overrides: SuiteTrackerOverride[];
};

/**
 * @generated from message pixel_tracker.v1.SuiteTrackerOverrides
 */
export type SuiteTrackerOverridesJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.SuiteTrackerOverride overrides = 1;
	 */
	overrides?: SuiteTrackerOverrideJson[];
};

/**
 * Describes the message pixel_tracker.v1.SuiteTrackerOverrides.
 * Use `create(SuiteTrackerOverridesSchema)` to create a new message.
 */
export const SuiteTrackerOverridesSchema: GenMessage<SuiteTrackerOverrides, { jsonType: SuiteTrackerOverridesJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 6);

/**
 * @generated from message pixel_tracker.v1.SuiteTrackerOverride
 */
export type SuiteTrackerOverride = Message<"pixel_tracker.v1.SuiteTrackerOverride"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType: TrackerEventType;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: bool is_conversion = 3;
	 */
	isConversion: boolean;
};

/**
 * @generated from message pixel_tracker.v1.SuiteTrackerOverride
 */
export type SuiteTrackerOverrideJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType?: TrackerEventTypeJson;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: bool is_conversion = 3;
	 */
	isConversion?: boolean;
};

/**
 * Describes the message pixel_tracker.v1.SuiteTrackerOverride.
 * Use `create(SuiteTrackerOverrideSchema)` to create a new message.
 */
export const SuiteTrackerOverrideSchema: GenMessage<SuiteTrackerOverride, { jsonType: SuiteTrackerOverrideJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 7);

/**
 * proto version of https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/tracker-setup/initialization-options/
 *
 * @generated from message pixel_tracker.v1.PixelConfiguration
 */
export type PixelConfiguration = Message<"pixel_tracker.v1.PixelConfiguration"> & {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Platform platform = 2;
	 */
	platform: Platform;

	/**
	 * @generated from field: string cookie_domain = 3;
	 */
	cookieDomain: string;

	/**
	 * @generated from field: bool discover_root_domain = 4;
	 */
	discoverRootDomain: boolean;

	/**
	 * @generated from field: string cookie_name = 5;
	 */
	cookieName: string;

	/**
	 * @generated from field: pixel_tracker.v1.CookieSameSite cookie_same_site = 6;
	 */
	cookieSameSite: CookieSameSite;

	/**
	 * @generated from field: bool cookie_secure = 7;
	 */
	cookieSecure: boolean;

	/**
	 * @generated from field: bool encode_base64 = 8;
	 */
	encodeBase64: boolean;

	/**
	 * @generated from field: bool respect_do_not_track = 9;
	 */
	respectDoNotTrack: boolean;

	/**
	 * @generated from field: pixel_tracker.v1.EventMethod event_method = 10;
	 */
	eventMethod: EventMethod;

	/**
	 * @generated from field: int32 buffer_size = 11;
	 */
	bufferSize: number;

	/**
	 * @generated from field: int64 max_post_bytes = 12;
	 */
	maxPostBytes: bigint;

	/**
	 * @generated from field: string post_path = 13;
	 */
	postPath: string;

	/**
	 * @generated from field: string cross_domain_linker = 14;
	 */
	crossDomainLinker: string;

	/**
	 * @generated from field: int64 cookie_lifetime = 15;
	 */
	cookieLifetime: bigint;

	/**
	 * @generated from field: pixel_tracker.v1.StateStorageStrategy state_storage_strategy = 16;
	 */
	stateStorageStrategy: StateStorageStrategy;

	/**
	 * @generated from field: int64 max_local_storage_queue_size = 17;
	 */
	maxLocalStorageQueueSize: bigint;

	/**
	 * @generated from field: bool reset_activity_tracking_on_page_view = 18;
	 */
	resetActivityTrackingOnPageView: boolean;

	/**
	 * @generated from field: int64 connection_timeout = 19;
	 */
	connectionTimeout: bigint;

	/**
	 * @generated from field: bool anonymous_tracking = 20;
	 */
	anonymousTracking: boolean;

	/**
	 * @generated from field: map<string, string> custom_headers = 21;
	 */
	customHeaders: { [key: string]: string };

	/**
	 * @generated from field: bool with_credentials = 22;
	 */
	withCredentials: boolean;

	/**
	 * @generated from field: repeated string contexts = 23;
	 */
	contexts: string[];

	/**
	 * @generated from field: repeated int32 retry_status_codes = 24;
	 */
	retryStatusCodes: number[];

	/**
	 * @generated from field: repeated int32 dont_retry_status_codes = 25;
	 */
	dontRetryStatusCodes: number[];

	/**
	 * @generated from field: bool retry_failed_requests = 26;
	 */
	retryFailedRequests: boolean;

	/**
	 * @generated from field: string on_session_update_callback = 27;
	 */
	onSessionUpdateCallback: string;

	/**
	 * @generated from field: string on_request_success = 28;
	 */
	onRequestSuccess: string;

	/**
	 * @generated from field: string on_request_failure = 29;
	 */
	onRequestFailure: string;

	/**
	 * @generated from field: pixel_tracker.v1.PreservePageViewIdForUrl preserve_page_view_id_for_url = 30;
	 */
	preservePageViewIdForUrl: PreservePageViewIdForUrl;
};

/**
 * proto version of https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/tracker-setup/initialization-options/
 *
 * @generated from message pixel_tracker.v1.PixelConfiguration
 */
export type PixelConfigurationJson = {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Platform platform = 2;
	 */
	platform?: PlatformJson;

	/**
	 * @generated from field: string cookie_domain = 3;
	 */
	cookieDomain?: string;

	/**
	 * @generated from field: bool discover_root_domain = 4;
	 */
	discoverRootDomain?: boolean;

	/**
	 * @generated from field: string cookie_name = 5;
	 */
	cookieName?: string;

	/**
	 * @generated from field: pixel_tracker.v1.CookieSameSite cookie_same_site = 6;
	 */
	cookieSameSite?: CookieSameSiteJson;

	/**
	 * @generated from field: bool cookie_secure = 7;
	 */
	cookieSecure?: boolean;

	/**
	 * @generated from field: bool encode_base64 = 8;
	 */
	encodeBase64?: boolean;

	/**
	 * @generated from field: bool respect_do_not_track = 9;
	 */
	respectDoNotTrack?: boolean;

	/**
	 * @generated from field: pixel_tracker.v1.EventMethod event_method = 10;
	 */
	eventMethod?: EventMethodJson;

	/**
	 * @generated from field: int32 buffer_size = 11;
	 */
	bufferSize?: number;

	/**
	 * @generated from field: int64 max_post_bytes = 12;
	 */
	maxPostBytes?: string;

	/**
	 * @generated from field: string post_path = 13;
	 */
	postPath?: string;

	/**
	 * @generated from field: string cross_domain_linker = 14;
	 */
	crossDomainLinker?: string;

	/**
	 * @generated from field: int64 cookie_lifetime = 15;
	 */
	cookieLifetime?: string;

	/**
	 * @generated from field: pixel_tracker.v1.StateStorageStrategy state_storage_strategy = 16;
	 */
	stateStorageStrategy?: StateStorageStrategyJson;

	/**
	 * @generated from field: int64 max_local_storage_queue_size = 17;
	 */
	maxLocalStorageQueueSize?: string;

	/**
	 * @generated from field: bool reset_activity_tracking_on_page_view = 18;
	 */
	resetActivityTrackingOnPageView?: boolean;

	/**
	 * @generated from field: int64 connection_timeout = 19;
	 */
	connectionTimeout?: string;

	/**
	 * @generated from field: bool anonymous_tracking = 20;
	 */
	anonymousTracking?: boolean;

	/**
	 * @generated from field: map<string, string> custom_headers = 21;
	 */
	customHeaders?: { [key: string]: string };

	/**
	 * @generated from field: bool with_credentials = 22;
	 */
	withCredentials?: boolean;

	/**
	 * @generated from field: repeated string contexts = 23;
	 */
	contexts?: string[];

	/**
	 * @generated from field: repeated int32 retry_status_codes = 24;
	 */
	retryStatusCodes?: number[];

	/**
	 * @generated from field: repeated int32 dont_retry_status_codes = 25;
	 */
	dontRetryStatusCodes?: number[];

	/**
	 * @generated from field: bool retry_failed_requests = 26;
	 */
	retryFailedRequests?: boolean;

	/**
	 * @generated from field: string on_session_update_callback = 27;
	 */
	onSessionUpdateCallback?: string;

	/**
	 * @generated from field: string on_request_success = 28;
	 */
	onRequestSuccess?: string;

	/**
	 * @generated from field: string on_request_failure = 29;
	 */
	onRequestFailure?: string;

	/**
	 * @generated from field: pixel_tracker.v1.PreservePageViewIdForUrl preserve_page_view_id_for_url = 30;
	 */
	preservePageViewIdForUrl?: PreservePageViewIdForUrlJson;
};

/**
 * Describes the message pixel_tracker.v1.PixelConfiguration.
 * Use `create(PixelConfigurationSchema)` to create a new message.
 */
export const PixelConfigurationSchema: GenMessage<PixelConfiguration, { jsonType: PixelConfigurationJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 8);

/**
 * @generated from message pixel_tracker.v1.TrackerEvent
 */
export type TrackerEvent = Message<"pixel_tracker.v1.TrackerEvent"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType: TrackerEventType;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 8;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: string name = 9;
	 */
	name: string;

	/**
	 * @generated from field: bool is_conversion = 6;
	 */
	isConversion: boolean;

	/**
	 * @generated from oneof pixel_tracker.v1.TrackerEvent.config
	 */
	config:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.PageviewTrackerConfig pageview_tracker_config = 2;
				 */
				value: PageviewTrackerConfig;
				case: "pageviewTrackerConfig";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.ActivityTrackerConfig activity_tracker_config = 3;
				 */
				value: ActivityTrackerConfig;
				case: "activityTrackerConfig";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.ButtonTrackerConfig button_tracker_config = 4;
				 */
				value: ButtonTrackerConfig;
				case: "buttonTrackerConfig";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.FormTrackerConfig form_tracker_config = 5;
				 */
				value: FormTrackerConfig;
				case: "formTrackerConfig";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.CustomTrackerConfig custom_tracker_config = 7;
				 */
				value: CustomTrackerConfig;
				case: "customTrackerConfig";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.ShopifyTrackerConfig shopify_tracker_config = 10;
				 */
				value: ShopifyTrackerConfig;
				case: "shopifyTrackerConfig";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message pixel_tracker.v1.TrackerEvent
 */
export type TrackerEventJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerEventType tracker_event_type = 1;
	 */
	trackerEventType?: TrackerEventTypeJson;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 8;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: string name = 9;
	 */
	name?: string;

	/**
	 * @generated from field: bool is_conversion = 6;
	 */
	isConversion?: boolean;

	/**
	 * @generated from field: pixel_tracker.v1.PageviewTrackerConfig pageview_tracker_config = 2;
	 */
	pageviewTrackerConfig?: PageviewTrackerConfigJson;

	/**
	 * @generated from field: pixel_tracker.v1.ActivityTrackerConfig activity_tracker_config = 3;
	 */
	activityTrackerConfig?: ActivityTrackerConfigJson;

	/**
	 * @generated from field: pixel_tracker.v1.ButtonTrackerConfig button_tracker_config = 4;
	 */
	buttonTrackerConfig?: ButtonTrackerConfigJson;

	/**
	 * @generated from field: pixel_tracker.v1.FormTrackerConfig form_tracker_config = 5;
	 */
	formTrackerConfig?: FormTrackerConfigJson;

	/**
	 * @generated from field: pixel_tracker.v1.CustomTrackerConfig custom_tracker_config = 7;
	 */
	customTrackerConfig?: CustomTrackerConfigJson;

	/**
	 * @generated from field: pixel_tracker.v1.ShopifyTrackerConfig shopify_tracker_config = 10;
	 */
	shopifyTrackerConfig?: ShopifyTrackerConfigJson;
};

/**
 * Describes the message pixel_tracker.v1.TrackerEvent.
 * Use `create(TrackerEventSchema)` to create a new message.
 */
export const TrackerEventSchema: GenMessage<TrackerEvent, { jsonType: TrackerEventJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 9);

/**
 * @generated from message pixel_tracker.v1.PurchaseMapping
 */
export type PurchaseMapping = Message<"pixel_tracker.v1.PurchaseMapping"> & {
	/**
	 * @generated from field: map<string, pixel_tracker.v1.OrderMappingFields> fields = 1;
	 */
	fields: { [key: string]: OrderMappingFields };
};

/**
 * @generated from message pixel_tracker.v1.PurchaseMapping
 */
export type PurchaseMappingJson = {
	/**
	 * @generated from field: map<string, pixel_tracker.v1.OrderMappingFields> fields = 1;
	 */
	fields?: { [key: string]: OrderMappingFieldsJson };
};

/**
 * Describes the message pixel_tracker.v1.PurchaseMapping.
 * Use `create(PurchaseMappingSchema)` to create a new message.
 */
export const PurchaseMappingSchema: GenMessage<PurchaseMapping, { jsonType: PurchaseMappingJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 10);

/**
 * @generated from message pixel_tracker.v1.IdentityMapping
 */
export type IdentityMapping = Message<"pixel_tracker.v1.IdentityMapping"> & {
	/**
	 * @generated from field: map<string, pixel_tracker.v1.IdentityMappingFields> fields = 2;
	 */
	fields: { [key: string]: IdentityMappingFields };
};

/**
 * @generated from message pixel_tracker.v1.IdentityMapping
 */
export type IdentityMappingJson = {
	/**
	 * @generated from field: map<string, pixel_tracker.v1.IdentityMappingFields> fields = 2;
	 */
	fields?: { [key: string]: IdentityMappingFieldsJson };
};

/**
 * Describes the message pixel_tracker.v1.IdentityMapping.
 * Use `create(IdentityMappingSchema)` to create a new message.
 */
export const IdentityMappingSchema: GenMessage<IdentityMapping, { jsonType: IdentityMappingJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 11);

/**
 * @generated from message pixel_tracker.v1.CollectorContextData
 */
export type CollectorContextData = Message<"pixel_tracker.v1.CollectorContextData"> & {
	/**
	 * @generated from field: string aid = 1;
	 */
	aid: string;

	/**
	 * @generated from field: string cd = 2;
	 */
	cd: string;

	/**
	 * @generated from field: string cookie = 3;
	 */
	cookie: string;

	/**
	 * @generated from field: string cs = 4;
	 */
	cs: string;

	/**
	 * @generated from field: string cx = 5;
	 */
	cx: string;

	/**
	 * @generated from field: string ds = 6;
	 */
	ds: string;

	/**
	 * @generated from field: string dtm = 7;
	 */
	dtm: string;

	/**
	 * @generated from field: string duid = 8;
	 */
	duid: string;

	/**
	 * @generated from field: string e = 9;
	 */
	e: string;

	/**
	 * @generated from field: string eid = 10;
	 */
	eid: string;

	/**
	 * @generated from field: string lang = 11;
	 */
	lang: string;

	/**
	 * @generated from field: string p = 12;
	 */
	p: string;

	/**
	 * @generated from field: string page = 13;
	 */
	page: string;

	/**
	 * @generated from field: string pp_max = 27;
	 */
	ppMax: string;

	/**
	 * @generated from field: string pp_mix = 28;
	 */
	ppMix: string;

	/**
	 * @generated from field: string pp_may = 14;
	 */
	ppMay: string;

	/**
	 * @generated from field: string pp_miy = 15;
	 */
	ppMiy: string;

	/**
	 * @generated from field: string refr = 16;
	 */
	refr: string;

	/**
	 * @generated from field: string res = 17;
	 */
	res: string;

	/**
	 * @generated from field: string sid = 18;
	 */
	sid: string;

	/**
	 * @generated from field: string stm = 19;
	 */
	stm: string;

	/**
	 * @generated from field: string tna = 20;
	 */
	tna: string;

	/**
	 * @generated from field: string tv = 21;
	 */
	tv: string;

	/**
	 * @generated from field: string tz = 22;
	 */
	tz: string;

	/**
	 * @generated from field: string ue_px = 23;
	 */
	uePx: string;

	/**
	 * @generated from field: string url = 24;
	 */
	url: string;

	/**
	 * @generated from field: string vid = 25;
	 */
	vid: string;

	/**
	 * @generated from field: string vp = 26;
	 */
	vp: string;
};

/**
 * @generated from message pixel_tracker.v1.CollectorContextData
 */
export type CollectorContextDataJson = {
	/**
	 * @generated from field: string aid = 1;
	 */
	aid?: string;

	/**
	 * @generated from field: string cd = 2;
	 */
	cd?: string;

	/**
	 * @generated from field: string cookie = 3;
	 */
	cookie?: string;

	/**
	 * @generated from field: string cs = 4;
	 */
	cs?: string;

	/**
	 * @generated from field: string cx = 5;
	 */
	cx?: string;

	/**
	 * @generated from field: string ds = 6;
	 */
	ds?: string;

	/**
	 * @generated from field: string dtm = 7;
	 */
	dtm?: string;

	/**
	 * @generated from field: string duid = 8;
	 */
	duid?: string;

	/**
	 * @generated from field: string e = 9;
	 */
	e?: string;

	/**
	 * @generated from field: string eid = 10;
	 */
	eid?: string;

	/**
	 * @generated from field: string lang = 11;
	 */
	lang?: string;

	/**
	 * @generated from field: string p = 12;
	 */
	p?: string;

	/**
	 * @generated from field: string page = 13;
	 */
	page?: string;

	/**
	 * @generated from field: string pp_max = 27;
	 */
	ppMax?: string;

	/**
	 * @generated from field: string pp_mix = 28;
	 */
	ppMix?: string;

	/**
	 * @generated from field: string pp_may = 14;
	 */
	ppMay?: string;

	/**
	 * @generated from field: string pp_miy = 15;
	 */
	ppMiy?: string;

	/**
	 * @generated from field: string refr = 16;
	 */
	refr?: string;

	/**
	 * @generated from field: string res = 17;
	 */
	res?: string;

	/**
	 * @generated from field: string sid = 18;
	 */
	sid?: string;

	/**
	 * @generated from field: string stm = 19;
	 */
	stm?: string;

	/**
	 * @generated from field: string tna = 20;
	 */
	tna?: string;

	/**
	 * @generated from field: string tv = 21;
	 */
	tv?: string;

	/**
	 * @generated from field: string tz = 22;
	 */
	tz?: string;

	/**
	 * @generated from field: string ue_px = 23;
	 */
	uePx?: string;

	/**
	 * @generated from field: string url = 24;
	 */
	url?: string;

	/**
	 * @generated from field: string vid = 25;
	 */
	vid?: string;

	/**
	 * @generated from field: string vp = 26;
	 */
	vp?: string;
};

/**
 * Describes the message pixel_tracker.v1.CollectorContextData.
 * Use `create(CollectorContextDataSchema)` to create a new message.
 */
export const CollectorContextDataSchema: GenMessage<CollectorContextData, { jsonType: CollectorContextDataJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 12);

/**
 * @generated from message pixel_tracker.v1.TrackerContext
 */
export type TrackerContext = Message<"pixel_tracker.v1.TrackerContext"> & {
	/**
	 * @generated from field: string schema = 1;
	 */
	schema: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextField data = 2;
	 */
	data: TrackerContextField[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerContext
 */
export type TrackerContextJson = {
	/**
	 * @generated from field: string schema = 1;
	 */
	schema?: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextField data = 2;
	 */
	data?: TrackerContextFieldJson[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerContext.
 * Use `create(TrackerContextSchema)` to create a new message.
 */
export const TrackerContextSchema: GenMessage<TrackerContext, { jsonType: TrackerContextJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 13);

/**
 * @generated from message pixel_tracker.v1.TrackerContextField
 */
export type TrackerContextField = Message<"pixel_tracker.v1.TrackerContextField"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextFieldType type = 2;
	 */
	type: TrackerContextFieldType;

	/**
	 * @generated from field: bool required = 8;
	 */
	required: boolean;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextFieldTag tags = 9;
	 */
	tags: TrackerContextFieldTag[];

	/**
	 * @generated from oneof pixel_tracker.v1.TrackerContextField.value
	 */
	value:
		| {
				/**
				 * @generated from field: string string_value = 3;
				 */
				value: string;
				case: "stringValue";
		  }
		| {
				/**
				 * @generated from field: double number_value = 4;
				 */
				value: number;
				case: "numberValue";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerContextStringArray string_array_value = 5;
				 */
				value: TrackerContextStringArray;
				case: "stringArrayValue";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerContextNumberArray number_array_value = 6;
				 */
				value: TrackerContextNumberArray;
				case: "numberArrayValue";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerContextIntArray int_array_value = 11;
				 */
				value: TrackerContextIntArray;
				case: "intArrayValue";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.NestedTrackerContext object_value = 7;
				 */
				value: NestedTrackerContext;
				case: "objectValue";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerContextObjectArray object_array_value = 10;
				 */
				value: TrackerContextObjectArray;
				case: "objectArrayValue";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message pixel_tracker.v1.TrackerContextField
 */
export type TrackerContextFieldJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextFieldType type = 2;
	 */
	type?: TrackerContextFieldTypeJson;

	/**
	 * @generated from field: bool required = 8;
	 */
	required?: boolean;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextFieldTag tags = 9;
	 */
	tags?: TrackerContextFieldTagJson[];

	/**
	 * @generated from field: string string_value = 3;
	 */
	stringValue?: string;

	/**
	 * @generated from field: double number_value = 4;
	 */
	numberValue?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextStringArray string_array_value = 5;
	 */
	stringArrayValue?: TrackerContextStringArrayJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextNumberArray number_array_value = 6;
	 */
	numberArrayValue?: TrackerContextNumberArrayJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextIntArray int_array_value = 11;
	 */
	intArrayValue?: TrackerContextIntArrayJson;

	/**
	 * @generated from field: pixel_tracker.v1.NestedTrackerContext object_value = 7;
	 */
	objectValue?: NestedTrackerContextJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContextObjectArray object_array_value = 10;
	 */
	objectArrayValue?: TrackerContextObjectArrayJson;
};

/**
 * Describes the message pixel_tracker.v1.TrackerContextField.
 * Use `create(TrackerContextFieldSchema)` to create a new message.
 */
export const TrackerContextFieldSchema: GenMessage<TrackerContextField, { jsonType: TrackerContextFieldJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 14);

/**
 * @generated from message pixel_tracker.v1.NestedTrackerContext
 */
export type NestedTrackerContext = Message<"pixel_tracker.v1.NestedTrackerContext"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextField data = 1;
	 */
	data: TrackerContextField[];
};

/**
 * @generated from message pixel_tracker.v1.NestedTrackerContext
 */
export type NestedTrackerContextJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContextField data = 1;
	 */
	data?: TrackerContextFieldJson[];
};

/**
 * Describes the message pixel_tracker.v1.NestedTrackerContext.
 * Use `create(NestedTrackerContextSchema)` to create a new message.
 */
export const NestedTrackerContextSchema: GenMessage<NestedTrackerContext, { jsonType: NestedTrackerContextJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 15);

/**
 * @generated from message pixel_tracker.v1.TrackerContextStringArray
 */
export type TrackerContextStringArray = Message<"pixel_tracker.v1.TrackerContextStringArray"> & {
	/**
	 * @generated from field: repeated string elements = 1;
	 */
	elements: string[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerContextStringArray
 */
export type TrackerContextStringArrayJson = {
	/**
	 * @generated from field: repeated string elements = 1;
	 */
	elements?: string[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerContextStringArray.
 * Use `create(TrackerContextStringArraySchema)` to create a new message.
 */
export const TrackerContextStringArraySchema: GenMessage<TrackerContextStringArray, { jsonType: TrackerContextStringArrayJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 16);

/**
 * @generated from message pixel_tracker.v1.TrackerContextNumberArray
 */
export type TrackerContextNumberArray = Message<"pixel_tracker.v1.TrackerContextNumberArray"> & {
	/**
	 * @generated from field: repeated double elements = 1;
	 */
	elements: number[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerContextNumberArray
 */
export type TrackerContextNumberArrayJson = {
	/**
	 * @generated from field: repeated double elements = 1;
	 */
	elements?: (number | "NaN" | "Infinity" | "-Infinity")[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerContextNumberArray.
 * Use `create(TrackerContextNumberArraySchema)` to create a new message.
 */
export const TrackerContextNumberArraySchema: GenMessage<TrackerContextNumberArray, { jsonType: TrackerContextNumberArrayJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 17);

/**
 * @generated from message pixel_tracker.v1.TrackerContextIntArray
 */
export type TrackerContextIntArray = Message<"pixel_tracker.v1.TrackerContextIntArray"> & {
	/**
	 * @generated from field: repeated int64 elements = 1;
	 */
	elements: bigint[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerContextIntArray
 */
export type TrackerContextIntArrayJson = {
	/**
	 * @generated from field: repeated int64 elements = 1;
	 */
	elements?: string[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerContextIntArray.
 * Use `create(TrackerContextIntArraySchema)` to create a new message.
 */
export const TrackerContextIntArraySchema: GenMessage<TrackerContextIntArray, { jsonType: TrackerContextIntArrayJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 18);

/**
 * @generated from message pixel_tracker.v1.TrackerContextObjectArray
 */
export type TrackerContextObjectArray = Message<"pixel_tracker.v1.TrackerContextObjectArray"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.NestedTrackerContext elements = 1;
	 */
	elements: NestedTrackerContext[];
};

/**
 * @generated from message pixel_tracker.v1.TrackerContextObjectArray
 */
export type TrackerContextObjectArrayJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.NestedTrackerContext elements = 1;
	 */
	elements?: NestedTrackerContextJson[];
};

/**
 * Describes the message pixel_tracker.v1.TrackerContextObjectArray.
 * Use `create(TrackerContextObjectArraySchema)` to create a new message.
 */
export const TrackerContextObjectArraySchema: GenMessage<TrackerContextObjectArray, { jsonType: TrackerContextObjectArrayJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 19);

/**
 * @generated from message pixel_tracker.v1.TrackerFilter
 */
export type TrackerFilter = Message<"pixel_tracker.v1.TrackerFilter"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterElement filter_element = 1;
	 */
	filterElement?: TrackerFilterElement;
};

/**
 * @generated from message pixel_tracker.v1.TrackerFilter
 */
export type TrackerFilterJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterElement filter_element = 1;
	 */
	filterElement?: TrackerFilterElementJson;
};

/**
 * Describes the message pixel_tracker.v1.TrackerFilter.
 * Use `create(TrackerFilterSchema)` to create a new message.
 */
export const TrackerFilterSchema: GenMessage<TrackerFilter, { jsonType: TrackerFilterJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 20);

/**
 * a group of conditional phrases (ie. a=1,b=2), all joined with the same operator (and, or)
 *
 * @generated from message pixel_tracker.v1.TrackerFilterConditionalList
 */
export type TrackerFilterConditionalList = Message<"pixel_tracker.v1.TrackerFilterConditionalList"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerFilterElement elements = 1;
	 */
	elements: TrackerFilterElement[];

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterOperator operator = 2;
	 */
	operator: TrackerFilterOperator;
};

/**
 * a group of conditional phrases (ie. a=1,b=2), all joined with the same operator (and, or)
 *
 * @generated from message pixel_tracker.v1.TrackerFilterConditionalList
 */
export type TrackerFilterConditionalListJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerFilterElement elements = 1;
	 */
	elements?: TrackerFilterElementJson[];

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterOperator operator = 2;
	 */
	operator?: TrackerFilterOperatorJson;
};

/**
 * Describes the message pixel_tracker.v1.TrackerFilterConditionalList.
 * Use `create(TrackerFilterConditionalListSchema)` to create a new message.
 */
export const TrackerFilterConditionalListSchema: GenMessage<TrackerFilterConditionalList, { jsonType: TrackerFilterConditionalListJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 21);

/**
 * @generated from message pixel_tracker.v1.TrackerFilterConditional
 */
export type TrackerFilterConditional = Message<"pixel_tracker.v1.TrackerFilterConditional"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterElementType element_type = 1;
	 */
	elementType: TrackerFilterElementType;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterCondition condition = 2;
	 */
	condition: TrackerFilterCondition;

	/**
	 * @generated from field: string value = 3;
	 */
	value: string;
};

/**
 * @generated from message pixel_tracker.v1.TrackerFilterConditional
 */
export type TrackerFilterConditionalJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterElementType element_type = 1;
	 */
	elementType?: TrackerFilterElementTypeJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterCondition condition = 2;
	 */
	condition?: TrackerFilterConditionJson;

	/**
	 * @generated from field: string value = 3;
	 */
	value?: string;
};

/**
 * Describes the message pixel_tracker.v1.TrackerFilterConditional.
 * Use `create(TrackerFilterConditionalSchema)` to create a new message.
 */
export const TrackerFilterConditionalSchema: GenMessage<TrackerFilterConditional, { jsonType: TrackerFilterConditionalJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 22);

/**
 * is either a single conditional (i.e a=1) or a list of conditionals joined by the same operator (and, or)
 *
 * @generated from message pixel_tracker.v1.TrackerFilterElement
 */
export type TrackerFilterElement = Message<"pixel_tracker.v1.TrackerFilterElement"> & {
	/**
	 * @generated from oneof pixel_tracker.v1.TrackerFilterElement.value
	 */
	value:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerFilterConditional conditional = 1;
				 */
				value: TrackerFilterConditional;
				case: "conditional";
		  }
		| {
				/**
				 * @generated from field: pixel_tracker.v1.TrackerFilterConditionalList conditional_list = 2;
				 */
				value: TrackerFilterConditionalList;
				case: "conditionalList";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * is either a single conditional (i.e a=1) or a list of conditionals joined by the same operator (and, or)
 *
 * @generated from message pixel_tracker.v1.TrackerFilterElement
 */
export type TrackerFilterElementJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterConditional conditional = 1;
	 */
	conditional?: TrackerFilterConditionalJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilterConditionalList conditional_list = 2;
	 */
	conditionalList?: TrackerFilterConditionalListJson;
};

/**
 * Describes the message pixel_tracker.v1.TrackerFilterElement.
 * Use `create(TrackerFilterElementSchema)` to create a new message.
 */
export const TrackerFilterElementSchema: GenMessage<TrackerFilterElement, { jsonType: TrackerFilterElementJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 23);

/**
 * @generated from message pixel_tracker.v1.ActivityTrackerConfig
 */
export type ActivityTrackerConfig = Message<"pixel_tracker.v1.ActivityTrackerConfig"> & {
	/**
	 * @generated from field: int32 minimum_visit_length = 1;
	 */
	minimumVisitLength: number;

	/**
	 * @generated from field: int32 heartbeat_delay = 2;
	 */
	heartbeatDelay: number;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 3;
	 */
	contexts: TrackerContext[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 4;
	 */
	paths: PageViewPath[];
};

/**
 * @generated from message pixel_tracker.v1.ActivityTrackerConfig
 */
export type ActivityTrackerConfigJson = {
	/**
	 * @generated from field: int32 minimum_visit_length = 1;
	 */
	minimumVisitLength?: number;

	/**
	 * @generated from field: int32 heartbeat_delay = 2;
	 */
	heartbeatDelay?: number;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 3;
	 */
	contexts?: TrackerContextJson[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 4;
	 */
	paths?: PageViewPathJson[];
};

/**
 * Describes the message pixel_tracker.v1.ActivityTrackerConfig.
 * Use `create(ActivityTrackerConfigSchema)` to create a new message.
 */
export const ActivityTrackerConfigSchema: GenMessage<ActivityTrackerConfig, { jsonType: ActivityTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 24);

/**
 * @generated from message pixel_tracker.v1.PageviewTrackerConfig
 */
export type PageviewTrackerConfig = Message<"pixel_tracker.v1.PageviewTrackerConfig"> & {
	/**
	 * @generated from field: pixel_tracker.v1.PageviewFilterMode filter_mode = 1;
	 */
	filterMode: PageviewFilterMode;

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 2;
	 */
	paths: PageViewPath[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 3;
	 */
	contexts: TrackerContext[];
};

/**
 * @generated from message pixel_tracker.v1.PageviewTrackerConfig
 */
export type PageviewTrackerConfigJson = {
	/**
	 * @generated from field: pixel_tracker.v1.PageviewFilterMode filter_mode = 1;
	 */
	filterMode?: PageviewFilterModeJson;

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 2;
	 */
	paths?: PageViewPathJson[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 3;
	 */
	contexts?: TrackerContextJson[];
};

/**
 * Describes the message pixel_tracker.v1.PageviewTrackerConfig.
 * Use `create(PageviewTrackerConfigSchema)` to create a new message.
 */
export const PageviewTrackerConfigSchema: GenMessage<PageviewTrackerConfig, { jsonType: PageviewTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 25);

/**
 * @generated from message pixel_tracker.v1.PageViewPath
 */
export type PageViewPath = Message<"pixel_tracker.v1.PageViewPath"> & {
	/**
	 * @generated from field: string path = 1;
	 */
	path: string;

	/**
	 * @generated from field: pixel_tracker.v1.PageviewMatchMode match_mode = 2;
	 */
	matchMode: PageviewMatchMode;
};

/**
 * @generated from message pixel_tracker.v1.PageViewPath
 */
export type PageViewPathJson = {
	/**
	 * @generated from field: string path = 1;
	 */
	path?: string;

	/**
	 * @generated from field: pixel_tracker.v1.PageviewMatchMode match_mode = 2;
	 */
	matchMode?: PageviewMatchModeJson;
};

/**
 * Describes the message pixel_tracker.v1.PageViewPath.
 * Use `create(PageViewPathSchema)` to create a new message.
 */
export const PageViewPathSchema: GenMessage<PageViewPath, { jsonType: PageViewPathJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 26);

/**
 * @generated from message pixel_tracker.v1.ButtonTrackerConfig
 */
export type ButtonTrackerConfig = Message<"pixel_tracker.v1.ButtonTrackerConfig"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter tracker_filter = 1;
	 */
	trackerFilter?: TrackerFilter;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 2;
	 */
	contexts: TrackerContext[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 3;
	 */
	paths: PageViewPath[];
};

/**
 * @generated from message pixel_tracker.v1.ButtonTrackerConfig
 */
export type ButtonTrackerConfigJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter tracker_filter = 1;
	 */
	trackerFilter?: TrackerFilterJson;

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 2;
	 */
	contexts?: TrackerContextJson[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 3;
	 */
	paths?: PageViewPathJson[];
};

/**
 * Describes the message pixel_tracker.v1.ButtonTrackerConfig.
 * Use `create(ButtonTrackerConfigSchema)` to create a new message.
 */
export const ButtonTrackerConfigSchema: GenMessage<ButtonTrackerConfig, { jsonType: ButtonTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 27);

/**
 * @generated from message pixel_tracker.v1.FormTrackerConfig
 */
export type FormTrackerConfig = Message<"pixel_tracker.v1.FormTrackerConfig"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter forms_filter = 1;
	 */
	formsFilter?: TrackerFilter;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter fields_filter = 2;
	 */
	fieldsFilter?: TrackerFilter;

	/**
	 * @generated from field: repeated pixel_tracker.v1.FormTrackerEvent form_tracker_events = 3;
	 */
	formTrackerEvents: FormTrackerEvent[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 4;
	 */
	contexts: TrackerContext[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 5;
	 */
	paths: PageViewPath[];
};

/**
 * @generated from message pixel_tracker.v1.FormTrackerConfig
 */
export type FormTrackerConfigJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter forms_filter = 1;
	 */
	formsFilter?: TrackerFilterJson;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerFilter fields_filter = 2;
	 */
	fieldsFilter?: TrackerFilterJson;

	/**
	 * @generated from field: repeated pixel_tracker.v1.FormTrackerEvent form_tracker_events = 3;
	 */
	formTrackerEvents?: FormTrackerEventJson[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.TrackerContext contexts = 4;
	 */
	contexts?: TrackerContextJson[];

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 5;
	 */
	paths?: PageViewPathJson[];
};

/**
 * Describes the message pixel_tracker.v1.FormTrackerConfig.
 * Use `create(FormTrackerConfigSchema)` to create a new message.
 */
export const FormTrackerConfigSchema: GenMessage<FormTrackerConfig, { jsonType: FormTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 28);

/**
 * @generated from message pixel_tracker.v1.CustomTrackerConfig
 */
export type CustomTrackerConfig = Message<"pixel_tracker.v1.CustomTrackerConfig"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 1;
	 */
	context?: TrackerContext;

	/**
	 * @generated from oneof pixel_tracker.v1.CustomTrackerConfig.conversion_mapping
	 */
	conversionMapping:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 5;
				 */
				value: PurchaseMapping;
				case: "purchaseMapping";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 6;
	 */
	identityMapping?: IdentityMapping;

	/**
	 * @generated from field: string source_context_template_id = 3;
	 */
	sourceContextTemplateId: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 4;
	 */
	paths: PageViewPath[];
};

/**
 * @generated from message pixel_tracker.v1.CustomTrackerConfig
 */
export type CustomTrackerConfigJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 1;
	 */
	context?: TrackerContextJson;

	/**
	 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 5;
	 */
	purchaseMapping?: PurchaseMappingJson;

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 6;
	 */
	identityMapping?: IdentityMappingJson;

	/**
	 * @generated from field: string source_context_template_id = 3;
	 */
	sourceContextTemplateId?: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.PageViewPath paths = 4;
	 */
	paths?: PageViewPathJson[];
};

/**
 * Describes the message pixel_tracker.v1.CustomTrackerConfig.
 * Use `create(CustomTrackerConfigSchema)` to create a new message.
 */
export const CustomTrackerConfigSchema: GenMessage<CustomTrackerConfig, { jsonType: CustomTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 29);

/**
 * @generated from message pixel_tracker.v1.ShopifyTrackerConfig
 */
export type ShopifyTrackerConfig = Message<"pixel_tracker.v1.ShopifyTrackerConfig"> & {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 1;
	 */
	context?: TrackerContext;

	/**
	 * @generated from oneof pixel_tracker.v1.ShopifyTrackerConfig.conversion_mapping
	 */
	conversionMapping:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 2;
				 */
				value: PurchaseMapping;
				case: "purchaseMapping";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 3;
	 */
	identityMapping?: IdentityMapping;

	/**
	 * @generated from field: string source_context_template_id = 4;
	 */
	sourceContextTemplateId: string;
};

/**
 * @generated from message pixel_tracker.v1.ShopifyTrackerConfig
 */
export type ShopifyTrackerConfigJson = {
	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 1;
	 */
	context?: TrackerContextJson;

	/**
	 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 2;
	 */
	purchaseMapping?: PurchaseMappingJson;

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 3;
	 */
	identityMapping?: IdentityMappingJson;

	/**
	 * @generated from field: string source_context_template_id = 4;
	 */
	sourceContextTemplateId?: string;
};

/**
 * Describes the message pixel_tracker.v1.ShopifyTrackerConfig.
 * Use `create(ShopifyTrackerConfigSchema)` to create a new message.
 */
export const ShopifyTrackerConfigSchema: GenMessage<ShopifyTrackerConfig, { jsonType: ShopifyTrackerConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 30);

/**
 * @generated from message pixel_tracker.v1.PixelQueryParam
 */
export type PixelQueryParam = Message<"pixel_tracker.v1.PixelQueryParam"> & {
	/**
	 * @generated from field: string rds_cookie = 1;
	 */
	rdsCookie: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * @generated from field: string ml_request_id = 4;
	 */
	mlRequestId: string;
};

/**
 * @generated from message pixel_tracker.v1.PixelQueryParam
 */
export type PixelQueryParamJson = {
	/**
	 * @generated from field: string rds_cookie = 1;
	 */
	rdsCookie?: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * @generated from field: string ml_request_id = 4;
	 */
	mlRequestId?: string;
};

/**
 * Describes the message pixel_tracker.v1.PixelQueryParam.
 * Use `create(PixelQueryParamSchema)` to create a new message.
 */
export const PixelQueryParamSchema: GenMessage<PixelQueryParam, { jsonType: PixelQueryParamJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 31);

/**
 * @generated from message pixel_tracker.v1.ImageTag
 */
export type ImageTag = Message<"pixel_tracker.v1.ImageTag"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string app_id = 2;
	 */
	appId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string display_name = 5;
	 */
	displayName: string;

	/**
	 * @generated from field: string collector_url = 6;
	 */
	collectorUrl: string;

	/**
	 * @generated from field: repeated string allowed_domains = 7;
	 */
	allowedDomains: string[];

	/**
	 * @generated from field: pixel_tracker.v1.ImageTagConfig config = 8;
	 */
	config?: ImageTagConfig;

	/**
	 * @generated from field: string creator_id = 9;
	 */
	creatorId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 12;
	 */
	deletedAt?: Timestamp;
};

/**
 * @generated from message pixel_tracker.v1.ImageTag
 */
export type ImageTagJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string app_id = 2;
	 */
	appId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string display_name = 5;
	 */
	displayName?: string;

	/**
	 * @generated from field: string collector_url = 6;
	 */
	collectorUrl?: string;

	/**
	 * @generated from field: repeated string allowed_domains = 7;
	 */
	allowedDomains?: string[];

	/**
	 * @generated from field: pixel_tracker.v1.ImageTagConfig config = 8;
	 */
	config?: ImageTagConfigJson;

	/**
	 * @generated from field: string creator_id = 9;
	 */
	creatorId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp deleted_at = 12;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message pixel_tracker.v1.ImageTag.
 * Use `create(ImageTagSchema)` to create a new message.
 */
export const ImageTagSchema: GenMessage<ImageTag, { jsonType: ImageTagJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 32);

/**
 * @generated from message pixel_tracker.v1.ImageTagConfig
 */
export type ImageTagConfig = Message<"pixel_tracker.v1.ImageTagConfig"> & {
	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 1;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from oneof pixel_tracker.v1.ImageTagConfig.conversion_mapping
	 */
	conversionMapping:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 2;
				 */
				value: PurchaseMapping;
				case: "purchaseMapping";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message pixel_tracker.v1.ImageTagConfig
 */
export type ImageTagConfigJson = {
	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 1;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 2;
	 */
	purchaseMapping?: PurchaseMappingJson;
};

/**
 * Describes the message pixel_tracker.v1.ImageTagConfig.
 * Use `create(ImageTagConfigSchema)` to create a new message.
 */
export const ImageTagConfigSchema: GenMessage<ImageTagConfig, { jsonType: ImageTagConfigJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 33);

/**
 * loose mirror of bundles.proto user object
 *
 * @generated from message pixel_tracker.v1.User
 */
export type User = Message<"pixel_tracker.v1.User"> & {
	/**
	 * A GUID of the user
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string phone = 5;
	 */
	phone: string;
};

/**
 * loose mirror of bundles.proto user object
 *
 * @generated from message pixel_tracker.v1.User
 */
export type UserJson = {
	/**
	 * A GUID of the user
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string phone = 5;
	 */
	phone?: string;
};

/**
 * Describes the message pixel_tracker.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User, { jsonType: UserJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 34);

/**
 * @generated from message pixel_tracker.v1.JsonSchema
 */
export type JsonSchema = Message<"pixel_tracker.v1.JsonSchema"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;

	/**
	 * @generated from field: google.protobuf.Struct schema = 4;
	 */
	schema?: JsonObject;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp;
};

/**
 * @generated from message pixel_tracker.v1.JsonSchema
 */
export type JsonSchemaJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;

	/**
	 * @generated from field: google.protobuf.Struct schema = 4;
	 */
	schema?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message pixel_tracker.v1.JsonSchema.
 * Use `create(JsonSchemaSchema)` to create a new message.
 */
export const JsonSchemaSchema: GenMessage<JsonSchema, { jsonType: JsonSchemaJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 35);

/**
 * @generated from message pixel_tracker.v1.ContextTemplate
 */
export type ContextTemplate = Message<"pixel_tracker.v1.ContextTemplate"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 3;
	 */
	context?: TrackerContext;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from oneof pixel_tracker.v1.ContextTemplate.conversion_mapping
	 */
	conversionMapping:
		| {
				/**
				 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 8;
				 */
				value: PurchaseMapping;
				case: "purchaseMapping";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 10;
	 */
	identityMapping?: IdentityMapping;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 4;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 5;
	 */
	updatedAt?: Timestamp;
};

/**
 * @generated from message pixel_tracker.v1.ContextTemplate
 */
export type ContextTemplateJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.TrackerContext context = 3;
	 */
	context?: TrackerContextJson;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: pixel_tracker.v1.PurchaseMapping purchase_mapping = 8;
	 */
	purchaseMapping?: PurchaseMappingJson;

	/**
	 * @generated from field: pixel_tracker.v1.IdentityMapping identity_mapping = 10;
	 */
	identityMapping?: IdentityMappingJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 4;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 5;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message pixel_tracker.v1.ContextTemplate.
 * Use `create(ContextTemplateSchema)` to create a new message.
 */
export const ContextTemplateSchema: GenMessage<ContextTemplate, { jsonType: ContextTemplateJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 36);

/**
 * @generated from message pixel_tracker.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"pixel_tracker.v1.CreateTagRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.CreateTagRequest
 */
export type CreateTagRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest, { jsonType: CreateTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 37);

/**
 * @generated from message pixel_tracker.v1.CreateTagResponse
 */
export type CreateTagResponse = Message<"pixel_tracker.v1.CreateTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.CreateTagResponse
 */
export type CreateTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateTagResponse.
 * Use `create(CreateTagResponseSchema)` to create a new message.
 */
export const CreateTagResponseSchema: GenMessage<CreateTagResponse, { jsonType: CreateTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 38);

/**
 * @generated from message pixel_tracker.v1.GetTagRequest
 */
export type GetTagRequest = Message<"pixel_tracker.v1.GetTagRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;
};

/**
 * @generated from message pixel_tracker.v1.GetTagRequest
 */
export type GetTagRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetTagRequest.
 * Use `create(GetTagRequestSchema)` to create a new message.
 */
export const GetTagRequestSchema: GenMessage<GetTagRequest, { jsonType: GetTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 39);

/**
 * @generated from message pixel_tracker.v1.GetTagResponse
 */
export type GetTagResponse = Message<"pixel_tracker.v1.GetTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.GetTagResponse
 */
export type GetTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.GetTagResponse.
 * Use `create(GetTagResponseSchema)` to create a new message.
 */
export const GetTagResponseSchema: GenMessage<GetTagResponse, { jsonType: GetTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 40);

/**
 * @generated from message pixel_tracker.v1.GenerateStaticTagCodeRequest
 */
export type GenerateStaticTagCodeRequest = Message<"pixel_tracker.v1.GenerateStaticTagCodeRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateStaticTagCodeRequest
 */
export type GenerateStaticTagCodeRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateStaticTagCodeRequest.
 * Use `create(GenerateStaticTagCodeRequestSchema)` to create a new message.
 */
export const GenerateStaticTagCodeRequestSchema: GenMessage<GenerateStaticTagCodeRequest, { jsonType: GenerateStaticTagCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 41);

/**
 * @generated from message pixel_tracker.v1.GenerateStaticTagCodeResponse
 */
export type GenerateStaticTagCodeResponse = Message<"pixel_tracker.v1.GenerateStaticTagCodeResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;

	/**
	 * @generated from field: string tag_code = 5;
	 */
	tagCode: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateStaticTagCodeResponse
 */
export type GenerateStaticTagCodeResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string tag_code = 5;
	 */
	tagCode?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateStaticTagCodeResponse.
 * Use `create(GenerateStaticTagCodeResponseSchema)` to create a new message.
 */
export const GenerateStaticTagCodeResponseSchema: GenMessage<GenerateStaticTagCodeResponse, { jsonType: GenerateStaticTagCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 42);

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionsRequest
 */
export type GenerateInlineTrackerFunctionsRequest = Message<"pixel_tracker.v1.GenerateInlineTrackerFunctionsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionsRequest
 */
export type GenerateInlineTrackerFunctionsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateInlineTrackerFunctionsRequest.
 * Use `create(GenerateInlineTrackerFunctionsRequestSchema)` to create a new message.
 */
export const GenerateInlineTrackerFunctionsRequestSchema: GenMessage<GenerateInlineTrackerFunctionsRequest, { jsonType: GenerateInlineTrackerFunctionsRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 43);

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionsResponse
 */
export type GenerateInlineTrackerFunctionsResponse = Message<"pixel_tracker.v1.GenerateInlineTrackerFunctionsResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;

	/**
	 * @generated from field: repeated string functions = 5;
	 */
	functions: string[];
};

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionsResponse
 */
export type GenerateInlineTrackerFunctionsResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;

	/**
	 * @generated from field: repeated string functions = 5;
	 */
	functions?: string[];
};

/**
 * Describes the message pixel_tracker.v1.GenerateInlineTrackerFunctionsResponse.
 * Use `create(GenerateInlineTrackerFunctionsResponseSchema)` to create a new message.
 */
export const GenerateInlineTrackerFunctionsResponseSchema: GenMessage<GenerateInlineTrackerFunctionsResponse, { jsonType: GenerateInlineTrackerFunctionsResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 44);

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionMapRequest
 */
export type GenerateInlineTrackerFunctionMapRequest = Message<"pixel_tracker.v1.GenerateInlineTrackerFunctionMapRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionMapRequest
 */
export type GenerateInlineTrackerFunctionMapRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateInlineTrackerFunctionMapRequest.
 * Use `create(GenerateInlineTrackerFunctionMapRequestSchema)` to create a new message.
 */
export const GenerateInlineTrackerFunctionMapRequestSchema: GenMessage<GenerateInlineTrackerFunctionMapRequest, { jsonType: GenerateInlineTrackerFunctionMapRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 45);

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionMapResponse
 */
export type GenerateInlineTrackerFunctionMapResponse = Message<"pixel_tracker.v1.GenerateInlineTrackerFunctionMapResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;

	/**
	 * @generated from field: map<string, string> functions = 5;
	 */
	functions: { [key: string]: string };
};

/**
 * @generated from message pixel_tracker.v1.GenerateInlineTrackerFunctionMapResponse
 */
export type GenerateInlineTrackerFunctionMapResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;

	/**
	 * @generated from field: map<string, string> functions = 5;
	 */
	functions?: { [key: string]: string };
};

/**
 * Describes the message pixel_tracker.v1.GenerateInlineTrackerFunctionMapResponse.
 * Use `create(GenerateInlineTrackerFunctionMapResponseSchema)` to create a new message.
 */
export const GenerateInlineTrackerFunctionMapResponseSchema: GenMessage<GenerateInlineTrackerFunctionMapResponse, { jsonType: GenerateInlineTrackerFunctionMapResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 46);

/**
 * @generated from message pixel_tracker.v1.UpdateTagRequest
 */
export type UpdateTagRequest = Message<"pixel_tracker.v1.UpdateTagRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateTagRequest
 */
export type UpdateTagRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateTagRequest.
 * Use `create(UpdateTagRequestSchema)` to create a new message.
 */
export const UpdateTagRequestSchema: GenMessage<UpdateTagRequest, { jsonType: UpdateTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 47);

/**
 * @generated from message pixel_tracker.v1.UpdateTagResponse
 */
export type UpdateTagResponse = Message<"pixel_tracker.v1.UpdateTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.UpdateTagResponse
 */
export type UpdateTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateTagResponse.
 * Use `create(UpdateTagResponseSchema)` to create a new message.
 */
export const UpdateTagResponseSchema: GenMessage<UpdateTagResponse, { jsonType: UpdateTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 48);

/**
 * @generated from message pixel_tracker.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"pixel_tracker.v1.ListTagsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated string ids = 3;
	 */
	ids: string[];

	/**
	 * @generated from field: string display_name = 5;
	 */
	displayName: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message pixel_tracker.v1.ListTagsRequest
 */
export type ListTagsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated string ids = 3;
	 */
	ids?: string[];

	/**
	 * @generated from field: string display_name = 5;
	 */
	displayName?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message pixel_tracker.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest, { jsonType: ListTagsRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 49);

/**
 * @generated from message pixel_tracker.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"pixel_tracker.v1.ListTagsResponse"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.Tag tags = 1;
	 */
	tags: Tag[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message pixel_tracker.v1.ListTagsResponse
 */
export type ListTagsResponseJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.Tag tags = 1;
	 */
	tags?: TagJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message pixel_tracker.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse, { jsonType: ListTagsResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 50);

/**
 * @generated from message pixel_tracker.v1.ListWorkspaceTagsRequest
 */
export type ListWorkspaceTagsRequest = Message<"pixel_tracker.v1.ListWorkspaceTagsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated string ids = 3;
	 */
	ids: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message pixel_tracker.v1.ListWorkspaceTagsRequest
 */
export type ListWorkspaceTagsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated string ids = 3;
	 */
	ids?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message pixel_tracker.v1.ListWorkspaceTagsRequest.
 * Use `create(ListWorkspaceTagsRequestSchema)` to create a new message.
 */
export const ListWorkspaceTagsRequestSchema: GenMessage<ListWorkspaceTagsRequest, { jsonType: ListWorkspaceTagsRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 51);

/**
 * @generated from message pixel_tracker.v1.ListWorkspaceTagsResponse
 */
export type ListWorkspaceTagsResponse = Message<"pixel_tracker.v1.ListWorkspaceTagsResponse"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.Tag tags = 1;
	 */
	tags: Tag[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message pixel_tracker.v1.ListWorkspaceTagsResponse
 */
export type ListWorkspaceTagsResponseJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.Tag tags = 1;
	 */
	tags?: TagJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message pixel_tracker.v1.ListWorkspaceTagsResponse.
 * Use `create(ListWorkspaceTagsResponseSchema)` to create a new message.
 */
export const ListWorkspaceTagsResponseSchema: GenMessage<ListWorkspaceTagsResponse, { jsonType: ListWorkspaceTagsResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 52);

/**
 * @generated from message pixel_tracker.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"pixel_tracker.v1.DeleteTagRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 4;
	 */
	tagId: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteTagRequest
 */
export type DeleteTagRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 4;
	 */
	tagId?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest, { jsonType: DeleteTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 53);

/**
 * @generated from message pixel_tracker.v1.DeleteTagResponse
 */
export type DeleteTagResponse = Message<"pixel_tracker.v1.DeleteTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.DeleteTagResponse
 */
export type DeleteTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.DeleteTagResponse.
 * Use `create(DeleteTagResponseSchema)` to create a new message.
 */
export const DeleteTagResponseSchema: GenMessage<DeleteTagResponse, { jsonType: DeleteTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 54);

/**
 * @generated from message pixel_tracker.v1.GenerateTagCodeRequest
 */
export type GenerateTagCodeRequest = Message<"pixel_tracker.v1.GenerateTagCodeRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateTagCodeRequest
 */
export type GenerateTagCodeRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateTagCodeRequest.
 * Use `create(GenerateTagCodeRequestSchema)` to create a new message.
 */
export const GenerateTagCodeRequestSchema: GenMessage<GenerateTagCodeRequest, { jsonType: GenerateTagCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 55);

/**
 * @generated from message pixel_tracker.v1.GenerateTagCodeResponse
 */
export type GenerateTagCodeResponse = Message<"pixel_tracker.v1.GenerateTagCodeResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId: string;

	/**
	 * @generated from field: string tag_code = 4;
	 */
	tagCode: string;

	/**
	 * @generated from field: string form_reload_function = 5;
	 */
	formReloadFunction: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateTagCodeResponse
 */
export type GenerateTagCodeResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tag_id = 3;
	 */
	tagId?: string;

	/**
	 * @generated from field: string tag_code = 4;
	 */
	tagCode?: string;

	/**
	 * @generated from field: string form_reload_function = 5;
	 */
	formReloadFunction?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateTagCodeResponse.
 * Use `create(GenerateTagCodeResponseSchema)` to create a new message.
 */
export const GenerateTagCodeResponseSchema: GenMessage<GenerateTagCodeResponse, { jsonType: GenerateTagCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 56);

/**
 * @generated from message pixel_tracker.v1.CreateSuiteOverrideRequest
 */
export type CreateSuiteOverrideRequest = Message<"pixel_tracker.v1.CreateSuiteOverrideRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.CreateSuiteOverrideRequest
 */
export type CreateSuiteOverrideRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateSuiteOverrideRequest.
 * Use `create(CreateSuiteOverrideRequestSchema)` to create a new message.
 */
export const CreateSuiteOverrideRequestSchema: GenMessage<CreateSuiteOverrideRequest, { jsonType: CreateSuiteOverrideRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 57);

/**
 * @generated from message pixel_tracker.v1.CreateSuiteOverrideResponse
 */
export type CreateSuiteOverrideResponse = Message<"pixel_tracker.v1.CreateSuiteOverrideResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.CreateSuiteOverrideResponse
 */
export type CreateSuiteOverrideResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateSuiteOverrideResponse.
 * Use `create(CreateSuiteOverrideResponseSchema)` to create a new message.
 */
export const CreateSuiteOverrideResponseSchema: GenMessage<CreateSuiteOverrideResponse, { jsonType: CreateSuiteOverrideResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 58);

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideRequest
 */
export type GetSuiteOverrideRequest = Message<"pixel_tracker.v1.GetSuiteOverrideRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_override_id = 3;
	 */
	suiteOverrideId: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version: string;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideRequest
 */
export type GetSuiteOverrideRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_override_id = 3;
	 */
	suiteOverrideId?: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteOverrideRequest.
 * Use `create(GetSuiteOverrideRequestSchema)` to create a new message.
 */
export const GetSuiteOverrideRequestSchema: GenMessage<GetSuiteOverrideRequest, { jsonType: GetSuiteOverrideRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 59);

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideResponse
 */
export type GetSuiteOverrideResponse = Message<"pixel_tracker.v1.GetSuiteOverrideResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideResponse
 */
export type GetSuiteOverrideResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteOverrideResponse.
 * Use `create(GetSuiteOverrideResponseSchema)` to create a new message.
 */
export const GetSuiteOverrideResponseSchema: GenMessage<GetSuiteOverrideResponse, { jsonType: GetSuiteOverrideResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 60);

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdRequest
 */
export type GetSuiteOverrideByTagAndSuiteIdRequest = Message<"pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdRequest"> & {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdRequest
 */
export type GetSuiteOverrideByTagAndSuiteIdRequestJson = {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdRequest.
 * Use `create(GetSuiteOverrideByTagAndSuiteIdRequestSchema)` to create a new message.
 */
export const GetSuiteOverrideByTagAndSuiteIdRequestSchema: GenMessage<GetSuiteOverrideByTagAndSuiteIdRequest, { jsonType: GetSuiteOverrideByTagAndSuiteIdRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 61);

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdResponse
 */
export type GetSuiteOverrideByTagAndSuiteIdResponse = Message<"pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 1;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdResponse
 */
export type GetSuiteOverrideByTagAndSuiteIdResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 1;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteOverrideByTagAndSuiteIdResponse.
 * Use `create(GetSuiteOverrideByTagAndSuiteIdResponseSchema)` to create a new message.
 */
export const GetSuiteOverrideByTagAndSuiteIdResponseSchema: GenMessage<GetSuiteOverrideByTagAndSuiteIdResponse, { jsonType: GetSuiteOverrideByTagAndSuiteIdResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 62);

/**
 * @generated from message pixel_tracker.v1.UpdateSuiteOverrideRequest
 */
export type UpdateSuiteOverrideRequest = Message<"pixel_tracker.v1.UpdateSuiteOverrideRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 4;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateSuiteOverrideRequest
 */
export type UpdateSuiteOverrideRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 4;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateSuiteOverrideRequest.
 * Use `create(UpdateSuiteOverrideRequestSchema)` to create a new message.
 */
export const UpdateSuiteOverrideRequestSchema: GenMessage<UpdateSuiteOverrideRequest, { jsonType: UpdateSuiteOverrideRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 63);

/**
 * @generated from message pixel_tracker.v1.UpdateSuiteOverrideResponse
 */
export type UpdateSuiteOverrideResponse = Message<"pixel_tracker.v1.UpdateSuiteOverrideResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.UpdateSuiteOverrideResponse
 */
export type UpdateSuiteOverrideResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateSuiteOverrideResponse.
 * Use `create(UpdateSuiteOverrideResponseSchema)` to create a new message.
 */
export const UpdateSuiteOverrideResponseSchema: GenMessage<UpdateSuiteOverrideResponse, { jsonType: UpdateSuiteOverrideResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 64);

/**
 * @generated from message pixel_tracker.v1.DeleteSuiteOverrideRequest
 */
export type DeleteSuiteOverrideRequest = Message<"pixel_tracker.v1.DeleteSuiteOverrideRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: string suite_override_id = 4;
	 */
	suiteOverrideId: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteSuiteOverrideRequest
 */
export type DeleteSuiteOverrideRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string suite_override_id = 4;
	 */
	suiteOverrideId?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteSuiteOverrideRequest.
 * Use `create(DeleteSuiteOverrideRequestSchema)` to create a new message.
 */
export const DeleteSuiteOverrideRequestSchema: GenMessage<DeleteSuiteOverrideRequest, { jsonType: DeleteSuiteOverrideRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 65);

/**
 * @generated from message pixel_tracker.v1.DeleteSuiteOverrideResponse
 */
export type DeleteSuiteOverrideResponse = Message<"pixel_tracker.v1.DeleteSuiteOverrideResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverride;
};

/**
 * @generated from message pixel_tracker.v1.DeleteSuiteOverrideResponse
 */
export type DeleteSuiteOverrideResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.SuiteOverride suite_override = 3;
	 */
	suiteOverride?: SuiteOverrideJson;
};

/**
 * Describes the message pixel_tracker.v1.DeleteSuiteOverrideResponse.
 * Use `create(DeleteSuiteOverrideResponseSchema)` to create a new message.
 */
export const DeleteSuiteOverrideResponseSchema: GenMessage<DeleteSuiteOverrideResponse, { jsonType: DeleteSuiteOverrideResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 66);

/**
 * @generated from message pixel_tracker.v1.CreateTrackerRequest
 */
export type CreateTrackerRequest = Message<"pixel_tracker.v1.CreateTrackerRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.CreateTrackerRequest
 */
export type CreateTrackerRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateTrackerRequest.
 * Use `create(CreateTrackerRequestSchema)` to create a new message.
 */
export const CreateTrackerRequestSchema: GenMessage<CreateTrackerRequest, { jsonType: CreateTrackerRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 67);

/**
 * @generated from message pixel_tracker.v1.CreateTrackerResponse
 */
export type CreateTrackerResponse = Message<"pixel_tracker.v1.CreateTrackerResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.CreateTrackerResponse
 */
export type CreateTrackerResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateTrackerResponse.
 * Use `create(CreateTrackerResponseSchema)` to create a new message.
 */
export const CreateTrackerResponseSchema: GenMessage<CreateTrackerResponse, { jsonType: CreateTrackerResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 68);

/**
 * @generated from message pixel_tracker.v1.GetTrackerRequest
 */
export type GetTrackerRequest = Message<"pixel_tracker.v1.GetTrackerRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string tracker_id = 3;
	 */
	trackerId: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version: string;
};

/**
 * @generated from message pixel_tracker.v1.GetTrackerRequest
 */
export type GetTrackerRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string tracker_id = 3;
	 */
	trackerId?: string;

	/**
	 * @generated from field: string version = 4;
	 */
	version?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetTrackerRequest.
 * Use `create(GetTrackerRequestSchema)` to create a new message.
 */
export const GetTrackerRequestSchema: GenMessage<GetTrackerRequest, { jsonType: GetTrackerRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 69);

/**
 * @generated from message pixel_tracker.v1.GetTrackerResponse
 */
export type GetTrackerResponse = Message<"pixel_tracker.v1.GetTrackerResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.GetTrackerResponse
 */
export type GetTrackerResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.GetTrackerResponse.
 * Use `create(GetTrackerResponseSchema)` to create a new message.
 */
export const GetTrackerResponseSchema: GenMessage<GetTrackerResponse, { jsonType: GetTrackerResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 70);

/**
 * @generated from message pixel_tracker.v1.GetTrackerByTagAndSuiteIdRequest
 */
export type GetTrackerByTagAndSuiteIdRequest = Message<"pixel_tracker.v1.GetTrackerByTagAndSuiteIdRequest"> & {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;
};

/**
 * @generated from message pixel_tracker.v1.GetTrackerByTagAndSuiteIdRequest
 */
export type GetTrackerByTagAndSuiteIdRequestJson = {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetTrackerByTagAndSuiteIdRequest.
 * Use `create(GetTrackerByTagAndSuiteIdRequestSchema)` to create a new message.
 */
export const GetTrackerByTagAndSuiteIdRequestSchema: GenMessage<GetTrackerByTagAndSuiteIdRequest, { jsonType: GetTrackerByTagAndSuiteIdRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 71);

/**
 * @generated from message pixel_tracker.v1.GetTrackerByTagAndSuiteIdResponse
 */
export type GetTrackerByTagAndSuiteIdResponse = Message<"pixel_tracker.v1.GetTrackerByTagAndSuiteIdResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 1;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.GetTrackerByTagAndSuiteIdResponse
 */
export type GetTrackerByTagAndSuiteIdResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 1;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.GetTrackerByTagAndSuiteIdResponse.
 * Use `create(GetTrackerByTagAndSuiteIdResponseSchema)` to create a new message.
 */
export const GetTrackerByTagAndSuiteIdResponseSchema: GenMessage<GetTrackerByTagAndSuiteIdResponse, { jsonType: GetTrackerByTagAndSuiteIdResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 72);

/**
 * @generated from message pixel_tracker.v1.UpdateTrackerRequest
 */
export type UpdateTrackerRequest = Message<"pixel_tracker.v1.UpdateTrackerRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 4;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateTrackerRequest
 */
export type UpdateTrackerRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 4;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateTrackerRequest.
 * Use `create(UpdateTrackerRequestSchema)` to create a new message.
 */
export const UpdateTrackerRequestSchema: GenMessage<UpdateTrackerRequest, { jsonType: UpdateTrackerRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 73);

/**
 * @generated from message pixel_tracker.v1.UpdateTrackerResponse
 */
export type UpdateTrackerResponse = Message<"pixel_tracker.v1.UpdateTrackerResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.UpdateTrackerResponse
 */
export type UpdateTrackerResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateTrackerResponse.
 * Use `create(UpdateTrackerResponseSchema)` to create a new message.
 */
export const UpdateTrackerResponseSchema: GenMessage<UpdateTrackerResponse, { jsonType: UpdateTrackerResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 74);

/**
 * @generated from message pixel_tracker.v1.DeleteTrackerRequest
 */
export type DeleteTrackerRequest = Message<"pixel_tracker.v1.DeleteTrackerRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: string tracker_id = 4;
	 */
	trackerId: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteTrackerRequest
 */
export type DeleteTrackerRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string tracker_id = 4;
	 */
	trackerId?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteTrackerRequest.
 * Use `create(DeleteTrackerRequestSchema)` to create a new message.
 */
export const DeleteTrackerRequestSchema: GenMessage<DeleteTrackerRequest, { jsonType: DeleteTrackerRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 75);

/**
 * @generated from message pixel_tracker.v1.DeleteTrackerResponse
 */
export type DeleteTrackerResponse = Message<"pixel_tracker.v1.DeleteTrackerResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: Tracker;
};

/**
 * @generated from message pixel_tracker.v1.DeleteTrackerResponse
 */
export type DeleteTrackerResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tracker tracker = 3;
	 */
	tracker?: TrackerJson;
};

/**
 * Describes the message pixel_tracker.v1.DeleteTrackerResponse.
 * Use `create(DeleteTrackerResponseSchema)` to create a new message.
 */
export const DeleteTrackerResponseSchema: GenMessage<DeleteTrackerResponse, { jsonType: DeleteTrackerResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 76);

/**
 * @generated from message pixel_tracker.v1.GeneratePixelCodeRequest
 */
export type GeneratePixelCodeRequest = Message<"pixel_tracker.v1.GeneratePixelCodeRequest"> & {
	/**
	 * @generated from field: string app_id_js = 1;
	 */
	appIdJs: string;

	/**
	 * @generated from field: string q = 2;
	 */
	q: string;
};

/**
 * @generated from message pixel_tracker.v1.GeneratePixelCodeRequest
 */
export type GeneratePixelCodeRequestJson = {
	/**
	 * @generated from field: string app_id_js = 1;
	 */
	appIdJs?: string;

	/**
	 * @generated from field: string q = 2;
	 */
	q?: string;
};

/**
 * Describes the message pixel_tracker.v1.GeneratePixelCodeRequest.
 * Use `create(GeneratePixelCodeRequestSchema)` to create a new message.
 */
export const GeneratePixelCodeRequestSchema: GenMessage<GeneratePixelCodeRequest, { jsonType: GeneratePixelCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 77);

/**
 * @generated from message pixel_tracker.v1.GeneratePixelCodeResponse
 */
export type GeneratePixelCodeResponse = Message<"pixel_tracker.v1.GeneratePixelCodeResponse"> & {
	/**
	 * @generated from field: google.api.HttpBody body = 1;
	 */
	body?: HttpBody;
};

/**
 * @generated from message pixel_tracker.v1.GeneratePixelCodeResponse
 */
export type GeneratePixelCodeResponseJson = {
	/**
	 * @generated from field: google.api.HttpBody body = 1;
	 */
	body?: HttpBodyJson;
};

/**
 * Describes the message pixel_tracker.v1.GeneratePixelCodeResponse.
 * Use `create(GeneratePixelCodeResponseSchema)` to create a new message.
 */
export const GeneratePixelCodeResponseSchema: GenMessage<GeneratePixelCodeResponse, { jsonType: GeneratePixelCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 78);

/**
 * @generated from message pixel_tracker.v1.GetAllDomainsRequest
 */
export type GetAllDomainsRequest = Message<"pixel_tracker.v1.GetAllDomainsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message pixel_tracker.v1.GetAllDomainsRequest
 */
export type GetAllDomainsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message pixel_tracker.v1.GetAllDomainsRequest.
 * Use `create(GetAllDomainsRequestSchema)` to create a new message.
 */
export const GetAllDomainsRequestSchema: GenMessage<GetAllDomainsRequest, { jsonType: GetAllDomainsRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 79);

/**
 * @generated from message pixel_tracker.v1.GetAllDomainsResponse
 */
export type GetAllDomainsResponse = Message<"pixel_tracker.v1.GetAllDomainsResponse"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated string domains = 3;
	 */
	domains: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 4;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message pixel_tracker.v1.GetAllDomainsResponse
 */
export type GetAllDomainsResponseJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated string domains = 3;
	 */
	domains?: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 4;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message pixel_tracker.v1.GetAllDomainsResponse.
 * Use `create(GetAllDomainsResponseSchema)` to create a new message.
 */
export const GetAllDomainsResponseSchema: GenMessage<GetAllDomainsResponse, { jsonType: GetAllDomainsResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 80);

/**
 * @generated from message pixel_tracker.v1.CollectPixelEventRequest
 */
export type CollectPixelEventRequest = Message<"pixel_tracker.v1.CollectPixelEventRequest"> & {
	/**
	 * @generated from field: string schema = 1;
	 */
	schema: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.CollectorContextData data = 2;
	 */
	data: CollectorContextData[];
};

/**
 * @generated from message pixel_tracker.v1.CollectPixelEventRequest
 */
export type CollectPixelEventRequestJson = {
	/**
	 * @generated from field: string schema = 1;
	 */
	schema?: string;

	/**
	 * @generated from field: repeated pixel_tracker.v1.CollectorContextData data = 2;
	 */
	data?: CollectorContextDataJson[];
};

/**
 * Describes the message pixel_tracker.v1.CollectPixelEventRequest.
 * Use `create(CollectPixelEventRequestSchema)` to create a new message.
 */
export const CollectPixelEventRequestSchema: GenMessage<CollectPixelEventRequest, { jsonType: CollectPixelEventRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 81);

/**
 * @generated from message pixel_tracker.v1.CollectPixelEventResponse
 */
export type CollectPixelEventResponse = Message<"pixel_tracker.v1.CollectPixelEventResponse"> & {};

/**
 * @generated from message pixel_tracker.v1.CollectPixelEventResponse
 */
export type CollectPixelEventResponseJson = {};

/**
 * Describes the message pixel_tracker.v1.CollectPixelEventResponse.
 * Use `create(CollectPixelEventResponseSchema)` to create a new message.
 */
export const CollectPixelEventResponseSchema: GenMessage<CollectPixelEventResponse, { jsonType: CollectPixelEventResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 82);

/**
 * @generated from message pixel_tracker.v1.CollectServerPixelEventRequest
 */
export type CollectServerPixelEventRequest = Message<"pixel_tracker.v1.CollectServerPixelEventRequest"> & {
	/**
	 * @generated from field: string fc_pid = 1;
	 */
	fcPid: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url: string;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: google.protobuf.Struct event_data = 4;
	 */
	eventData?: JsonObject;
};

/**
 * @generated from message pixel_tracker.v1.CollectServerPixelEventRequest
 */
export type CollectServerPixelEventRequestJson = {
	/**
	 * @generated from field: string fc_pid = 1;
	 */
	fcPid?: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url?: string;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.protobuf.Struct event_data = 4;
	 */
	eventData?: StructJson;
};

/**
 * Describes the message pixel_tracker.v1.CollectServerPixelEventRequest.
 * Use `create(CollectServerPixelEventRequestSchema)` to create a new message.
 */
export const CollectServerPixelEventRequestSchema: GenMessage<CollectServerPixelEventRequest, { jsonType: CollectServerPixelEventRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 83);

/**
 * @generated from message pixel_tracker.v1.CollectServerPixelEventResponse
 */
export type CollectServerPixelEventResponse = Message<"pixel_tracker.v1.CollectServerPixelEventResponse"> & {};

/**
 * @generated from message pixel_tracker.v1.CollectServerPixelEventResponse
 */
export type CollectServerPixelEventResponseJson = {};

/**
 * Describes the message pixel_tracker.v1.CollectServerPixelEventResponse.
 * Use `create(CollectServerPixelEventResponseSchema)` to create a new message.
 */
export const CollectServerPixelEventResponseSchema: GenMessage<CollectServerPixelEventResponse, { jsonType: CollectServerPixelEventResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 84);

/**
 * @generated from message pixel_tracker.v1.GetTagByAppIdRequest
 */
export type GetTagByAppIdRequest = Message<"pixel_tracker.v1.GetTagByAppIdRequest"> & {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId: string;
};

/**
 * @generated from message pixel_tracker.v1.GetTagByAppIdRequest
 */
export type GetTagByAppIdRequestJson = {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetTagByAppIdRequest.
 * Use `create(GetTagByAppIdRequestSchema)` to create a new message.
 */
export const GetTagByAppIdRequestSchema: GenMessage<GetTagByAppIdRequest, { jsonType: GetTagByAppIdRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 85);

/**
 * @generated from message pixel_tracker.v1.GetTagByAppIdResponse
 */
export type GetTagByAppIdResponse = Message<"pixel_tracker.v1.GetTagByAppIdResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.GetTagByAppIdResponse
 */
export type GetTagByAppIdResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.GetTagByAppIdResponse.
 * Use `create(GetTagByAppIdResponseSchema)` to create a new message.
 */
export const GetTagByAppIdResponseSchema: GenMessage<GetTagByAppIdResponse, { jsonType: GetTagByAppIdResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 86);

/**
 * @generated from message pixel_tracker.v1.GetSuiteTagRequest
 */
export type GetSuiteTagRequest = Message<"pixel_tracker.v1.GetSuiteTagRequest"> & {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteTagRequest
 */
export type GetSuiteTagRequestJson = {
	/**
	 * @generated from field: string tag_id = 1;
	 */
	tagId?: string;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteTagRequest.
 * Use `create(GetSuiteTagRequestSchema)` to create a new message.
 */
export const GetSuiteTagRequestSchema: GenMessage<GetSuiteTagRequest, { jsonType: GetSuiteTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 87);

/**
 * @generated from message pixel_tracker.v1.GetSuiteTagResponse
 */
export type GetSuiteTagResponse = Message<"pixel_tracker.v1.GetSuiteTagResponse"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 3;
	 */
	tag?: Tag;
};

/**
 * @generated from message pixel_tracker.v1.GetSuiteTagResponse
 */
export type GetSuiteTagResponseJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: pixel_tracker.v1.Tag tag = 3;
	 */
	tag?: TagJson;
};

/**
 * Describes the message pixel_tracker.v1.GetSuiteTagResponse.
 * Use `create(GetSuiteTagResponseSchema)` to create a new message.
 */
export const GetSuiteTagResponseSchema: GenMessage<GetSuiteTagResponse, { jsonType: GetSuiteTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 88);

/**
 * @generated from message pixel_tracker.v1.CreateContextTemplateRequest
 */
export type CreateContextTemplateRequest = Message<"pixel_tracker.v1.CreateContextTemplateRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplate;
};

/**
 * @generated from message pixel_tracker.v1.CreateContextTemplateRequest
 */
export type CreateContextTemplateRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplateJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateContextTemplateRequest.
 * Use `create(CreateContextTemplateRequestSchema)` to create a new message.
 */
export const CreateContextTemplateRequestSchema: GenMessage<CreateContextTemplateRequest, { jsonType: CreateContextTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 89);

/**
 * @generated from message pixel_tracker.v1.CreateContextTemplateResponse
 */
export type CreateContextTemplateResponse = Message<"pixel_tracker.v1.CreateContextTemplateResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplate;
};

/**
 * @generated from message pixel_tracker.v1.CreateContextTemplateResponse
 */
export type CreateContextTemplateResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplateJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateContextTemplateResponse.
 * Use `create(CreateContextTemplateResponseSchema)` to create a new message.
 */
export const CreateContextTemplateResponseSchema: GenMessage<CreateContextTemplateResponse, { jsonType: CreateContextTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 90);

/**
 * @generated from message pixel_tracker.v1.GetContextTemplateRequest
 */
export type GetContextTemplateRequest = Message<"pixel_tracker.v1.GetContextTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.GetContextTemplateRequest
 */
export type GetContextTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetContextTemplateRequest.
 * Use `create(GetContextTemplateRequestSchema)` to create a new message.
 */
export const GetContextTemplateRequestSchema: GenMessage<GetContextTemplateRequest, { jsonType: GetContextTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 91);

/**
 * @generated from message pixel_tracker.v1.GetContextTemplateResponse
 */
export type GetContextTemplateResponse = Message<"pixel_tracker.v1.GetContextTemplateResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplate;
};

/**
 * @generated from message pixel_tracker.v1.GetContextTemplateResponse
 */
export type GetContextTemplateResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplateJson;
};

/**
 * Describes the message pixel_tracker.v1.GetContextTemplateResponse.
 * Use `create(GetContextTemplateResponseSchema)` to create a new message.
 */
export const GetContextTemplateResponseSchema: GenMessage<GetContextTemplateResponse, { jsonType: GetContextTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 92);

/**
 * @generated from message pixel_tracker.v1.UpdateContextTemplateRequest
 */
export type UpdateContextTemplateRequest = Message<"pixel_tracker.v1.UpdateContextTemplateRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplate;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateContextTemplateRequest
 */
export type UpdateContextTemplateRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplateJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateContextTemplateRequest.
 * Use `create(UpdateContextTemplateRequestSchema)` to create a new message.
 */
export const UpdateContextTemplateRequestSchema: GenMessage<UpdateContextTemplateRequest, { jsonType: UpdateContextTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 93);

/**
 * @generated from message pixel_tracker.v1.UpdateContextTemplateResponse
 */
export type UpdateContextTemplateResponse = Message<"pixel_tracker.v1.UpdateContextTemplateResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplate;
};

/**
 * @generated from message pixel_tracker.v1.UpdateContextTemplateResponse
 */
export type UpdateContextTemplateResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ContextTemplate context_template = 1;
	 */
	contextTemplate?: ContextTemplateJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateContextTemplateResponse.
 * Use `create(UpdateContextTemplateResponseSchema)` to create a new message.
 */
export const UpdateContextTemplateResponseSchema: GenMessage<UpdateContextTemplateResponse, { jsonType: UpdateContextTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 94);

/**
 * @generated from message pixel_tracker.v1.DeleteContextTemplateRequest
 */
export type DeleteContextTemplateRequest = Message<"pixel_tracker.v1.DeleteContextTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteContextTemplateRequest
 */
export type DeleteContextTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteContextTemplateRequest.
 * Use `create(DeleteContextTemplateRequestSchema)` to create a new message.
 */
export const DeleteContextTemplateRequestSchema: GenMessage<DeleteContextTemplateRequest, { jsonType: DeleteContextTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 95);

/**
 * @generated from message pixel_tracker.v1.DeleteContextTemplateResponse
 */
export type DeleteContextTemplateResponse = Message<"pixel_tracker.v1.DeleteContextTemplateResponse"> & {};

/**
 * @generated from message pixel_tracker.v1.DeleteContextTemplateResponse
 */
export type DeleteContextTemplateResponseJson = {};

/**
 * Describes the message pixel_tracker.v1.DeleteContextTemplateResponse.
 * Use `create(DeleteContextTemplateResponseSchema)` to create a new message.
 */
export const DeleteContextTemplateResponseSchema: GenMessage<DeleteContextTemplateResponse, { jsonType: DeleteContextTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 96);

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaRequest
 */
export type CreateJsonSchemaRequest = Message<"pixel_tracker.v1.CreateJsonSchemaRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;
};

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaRequest
 */
export type CreateJsonSchemaRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateJsonSchemaRequest.
 * Use `create(CreateJsonSchemaRequestSchema)` to create a new message.
 */
export const CreateJsonSchemaRequestSchema: GenMessage<CreateJsonSchemaRequest, { jsonType: CreateJsonSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 97);

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaResponse
 */
export type CreateJsonSchemaResponse = Message<"pixel_tracker.v1.CreateJsonSchemaResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;
};

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaResponse
 */
export type CreateJsonSchemaResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateJsonSchemaResponse.
 * Use `create(CreateJsonSchemaResponseSchema)` to create a new message.
 */
export const CreateJsonSchemaResponseSchema: GenMessage<CreateJsonSchemaResponse, { jsonType: CreateJsonSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 98);

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaVersionRequest
 */
export type CreateJsonSchemaVersionRequest = Message<"pixel_tracker.v1.CreateJsonSchemaVersionRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;

	/**
	 * @generated from field: pixel_tracker.v1.SemanticVersionChangeType version_change_type = 2;
	 */
	versionChangeType: SemanticVersionChangeType;
};

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaVersionRequest
 */
export type CreateJsonSchemaVersionRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;

	/**
	 * @generated from field: pixel_tracker.v1.SemanticVersionChangeType version_change_type = 2;
	 */
	versionChangeType?: SemanticVersionChangeTypeJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateJsonSchemaVersionRequest.
 * Use `create(CreateJsonSchemaVersionRequestSchema)` to create a new message.
 */
export const CreateJsonSchemaVersionRequestSchema: GenMessage<CreateJsonSchemaVersionRequest, { jsonType: CreateJsonSchemaVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 99);

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaVersionResponse
 */
export type CreateJsonSchemaVersionResponse = Message<"pixel_tracker.v1.CreateJsonSchemaVersionResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;
};

/**
 * @generated from message pixel_tracker.v1.CreateJsonSchemaVersionResponse
 */
export type CreateJsonSchemaVersionResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateJsonSchemaVersionResponse.
 * Use `create(CreateJsonSchemaVersionResponseSchema)` to create a new message.
 */
export const CreateJsonSchemaVersionResponseSchema: GenMessage<CreateJsonSchemaVersionResponse, { jsonType: CreateJsonSchemaVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 100);

/**
 * @generated from message pixel_tracker.v1.GetJsonSchemaRequest
 */
export type GetJsonSchemaRequest = Message<"pixel_tracker.v1.GetJsonSchemaRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.GetJsonSchemaRequest
 */
export type GetJsonSchemaRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetJsonSchemaRequest.
 * Use `create(GetJsonSchemaRequestSchema)` to create a new message.
 */
export const GetJsonSchemaRequestSchema: GenMessage<GetJsonSchemaRequest, { jsonType: GetJsonSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 101);

/**
 * @generated from message pixel_tracker.v1.GetJsonSchemaResponse
 */
export type GetJsonSchemaResponse = Message<"pixel_tracker.v1.GetJsonSchemaResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;
};

/**
 * @generated from message pixel_tracker.v1.GetJsonSchemaResponse
 */
export type GetJsonSchemaResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;
};

/**
 * Describes the message pixel_tracker.v1.GetJsonSchemaResponse.
 * Use `create(GetJsonSchemaResponseSchema)` to create a new message.
 */
export const GetJsonSchemaResponseSchema: GenMessage<GetJsonSchemaResponse, { jsonType: GetJsonSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 102);

/**
 * @generated from message pixel_tracker.v1.UpdateJsonSchemaRequest
 */
export type UpdateJsonSchemaRequest = Message<"pixel_tracker.v1.UpdateJsonSchemaRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateJsonSchemaRequest
 */
export type UpdateJsonSchemaRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateJsonSchemaRequest.
 * Use `create(UpdateJsonSchemaRequestSchema)` to create a new message.
 */
export const UpdateJsonSchemaRequestSchema: GenMessage<UpdateJsonSchemaRequest, { jsonType: UpdateJsonSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 103);

/**
 * @generated from message pixel_tracker.v1.UpdateJsonSchemaResponse
 */
export type UpdateJsonSchemaResponse = Message<"pixel_tracker.v1.UpdateJsonSchemaResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchema;
};

/**
 * @generated from message pixel_tracker.v1.UpdateJsonSchemaResponse
 */
export type UpdateJsonSchemaResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.JsonSchema json_schema = 1;
	 */
	jsonSchema?: JsonSchemaJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateJsonSchemaResponse.
 * Use `create(UpdateJsonSchemaResponseSchema)` to create a new message.
 */
export const UpdateJsonSchemaResponseSchema: GenMessage<UpdateJsonSchemaResponse, { jsonType: UpdateJsonSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 104);

/**
 * @generated from message pixel_tracker.v1.DeleteJsonSchemaRequest
 */
export type DeleteJsonSchemaRequest = Message<"pixel_tracker.v1.DeleteJsonSchemaRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteJsonSchemaRequest
 */
export type DeleteJsonSchemaRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteJsonSchemaRequest.
 * Use `create(DeleteJsonSchemaRequestSchema)` to create a new message.
 */
export const DeleteJsonSchemaRequestSchema: GenMessage<DeleteJsonSchemaRequest, { jsonType: DeleteJsonSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 105);

/**
 * @generated from message pixel_tracker.v1.DeleteJsonSchemaResponse
 */
export type DeleteJsonSchemaResponse = Message<"pixel_tracker.v1.DeleteJsonSchemaResponse"> & {};

/**
 * @generated from message pixel_tracker.v1.DeleteJsonSchemaResponse
 */
export type DeleteJsonSchemaResponseJson = {};

/**
 * Describes the message pixel_tracker.v1.DeleteJsonSchemaResponse.
 * Use `create(DeleteJsonSchemaResponseSchema)` to create a new message.
 */
export const DeleteJsonSchemaResponseSchema: GenMessage<DeleteJsonSchemaResponse, { jsonType: DeleteJsonSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 106);

/**
 * @generated from message pixel_tracker.v1.ValidateCustomPayloadRequest
 */
export type ValidateCustomPayloadRequest = Message<"pixel_tracker.v1.ValidateCustomPayloadRequest"> & {
	/**
	 * @generated from field: string schema_name = 1;
	 */
	schemaName: string;

	/**
	 * @generated from field: google.protobuf.Struct payload = 2;
	 */
	payload?: JsonObject;
};

/**
 * @generated from message pixel_tracker.v1.ValidateCustomPayloadRequest
 */
export type ValidateCustomPayloadRequestJson = {
	/**
	 * @generated from field: string schema_name = 1;
	 */
	schemaName?: string;

	/**
	 * @generated from field: google.protobuf.Struct payload = 2;
	 */
	payload?: StructJson;
};

/**
 * Describes the message pixel_tracker.v1.ValidateCustomPayloadRequest.
 * Use `create(ValidateCustomPayloadRequestSchema)` to create a new message.
 */
export const ValidateCustomPayloadRequestSchema: GenMessage<ValidateCustomPayloadRequest, { jsonType: ValidateCustomPayloadRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 107);

/**
 * @generated from message pixel_tracker.v1.ValidateCustomPayloadResponse
 */
export type ValidateCustomPayloadResponse = Message<"pixel_tracker.v1.ValidateCustomPayloadResponse"> & {
	/**
	 * @generated from field: bool is_valid = 1;
	 */
	isValid: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 2;
	 */
	schema?: JsonObject;

	/**
	 * @generated from field: google.protobuf.Struct payload = 3;
	 */
	payload?: JsonObject;

	/**
	 * @generated from field: string error = 4;
	 */
	error: string;
};

/**
 * @generated from message pixel_tracker.v1.ValidateCustomPayloadResponse
 */
export type ValidateCustomPayloadResponseJson = {
	/**
	 * @generated from field: bool is_valid = 1;
	 */
	isValid?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct schema = 2;
	 */
	schema?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct payload = 3;
	 */
	payload?: StructJson;

	/**
	 * @generated from field: string error = 4;
	 */
	error?: string;
};

/**
 * Describes the message pixel_tracker.v1.ValidateCustomPayloadResponse.
 * Use `create(ValidateCustomPayloadResponseSchema)` to create a new message.
 */
export const ValidateCustomPayloadResponseSchema: GenMessage<ValidateCustomPayloadResponse, { jsonType: ValidateCustomPayloadResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 108);

/**
 * @generated from message pixel_tracker.v1.CreateImageTagRequest
 */
export type CreateImageTagRequest = Message<"pixel_tracker.v1.CreateImageTagRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;
};

/**
 * @generated from message pixel_tracker.v1.CreateImageTagRequest
 */
export type CreateImageTagRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateImageTagRequest.
 * Use `create(CreateImageTagRequestSchema)` to create a new message.
 */
export const CreateImageTagRequestSchema: GenMessage<CreateImageTagRequest, { jsonType: CreateImageTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 109);

/**
 * @generated from message pixel_tracker.v1.CreateImageTagResponse
 */
export type CreateImageTagResponse = Message<"pixel_tracker.v1.CreateImageTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;
};

/**
 * @generated from message pixel_tracker.v1.CreateImageTagResponse
 */
export type CreateImageTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;
};

/**
 * Describes the message pixel_tracker.v1.CreateImageTagResponse.
 * Use `create(CreateImageTagResponseSchema)` to create a new message.
 */
export const CreateImageTagResponseSchema: GenMessage<CreateImageTagResponse, { jsonType: CreateImageTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 110);

/**
 * @generated from message pixel_tracker.v1.GetImageTagRequest
 */
export type GetImageTagRequest = Message<"pixel_tracker.v1.GetImageTagRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.GetImageTagRequest
 */
export type GetImageTagRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetImageTagRequest.
 * Use `create(GetImageTagRequestSchema)` to create a new message.
 */
export const GetImageTagRequestSchema: GenMessage<GetImageTagRequest, { jsonType: GetImageTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 111);

/**
 * @generated from message pixel_tracker.v1.GetImageTagResponse
 */
export type GetImageTagResponse = Message<"pixel_tracker.v1.GetImageTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;
};

/**
 * @generated from message pixel_tracker.v1.GetImageTagResponse
 */
export type GetImageTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;
};

/**
 * Describes the message pixel_tracker.v1.GetImageTagResponse.
 * Use `create(GetImageTagResponseSchema)` to create a new message.
 */
export const GetImageTagResponseSchema: GenMessage<GetImageTagResponse, { jsonType: GetImageTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 112);

/**
 * @generated from message pixel_tracker.v1.GetImageTagByAppIdRequest
 */
export type GetImageTagByAppIdRequest = Message<"pixel_tracker.v1.GetImageTagByAppIdRequest"> & {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId: string;
};

/**
 * @generated from message pixel_tracker.v1.GetImageTagByAppIdRequest
 */
export type GetImageTagByAppIdRequestJson = {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId?: string;
};

/**
 * Describes the message pixel_tracker.v1.GetImageTagByAppIdRequest.
 * Use `create(GetImageTagByAppIdRequestSchema)` to create a new message.
 */
export const GetImageTagByAppIdRequestSchema: GenMessage<GetImageTagByAppIdRequest, { jsonType: GetImageTagByAppIdRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 113);

/**
 * @generated from message pixel_tracker.v1.GetImageTagByAppIdResponse
 */
export type GetImageTagByAppIdResponse = Message<"pixel_tracker.v1.GetImageTagByAppIdResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;
};

/**
 * @generated from message pixel_tracker.v1.GetImageTagByAppIdResponse
 */
export type GetImageTagByAppIdResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;
};

/**
 * Describes the message pixel_tracker.v1.GetImageTagByAppIdResponse.
 * Use `create(GetImageTagByAppIdResponseSchema)` to create a new message.
 */
export const GetImageTagByAppIdResponseSchema: GenMessage<GetImageTagByAppIdResponse, { jsonType: GetImageTagByAppIdResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 114);

/**
 * @generated from message pixel_tracker.v1.UpdateImageTagRequest
 */
export type UpdateImageTagRequest = Message<"pixel_tracker.v1.UpdateImageTagRequest"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message pixel_tracker.v1.UpdateImageTagRequest
 */
export type UpdateImageTagRequestJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateImageTagRequest.
 * Use `create(UpdateImageTagRequestSchema)` to create a new message.
 */
export const UpdateImageTagRequestSchema: GenMessage<UpdateImageTagRequest, { jsonType: UpdateImageTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 115);

/**
 * @generated from message pixel_tracker.v1.UpdateImageTagResponse
 */
export type UpdateImageTagResponse = Message<"pixel_tracker.v1.UpdateImageTagResponse"> & {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTag;
};

/**
 * @generated from message pixel_tracker.v1.UpdateImageTagResponse
 */
export type UpdateImageTagResponseJson = {
	/**
	 * @generated from field: pixel_tracker.v1.ImageTag image_tag = 1;
	 */
	imageTag?: ImageTagJson;
};

/**
 * Describes the message pixel_tracker.v1.UpdateImageTagResponse.
 * Use `create(UpdateImageTagResponseSchema)` to create a new message.
 */
export const UpdateImageTagResponseSchema: GenMessage<UpdateImageTagResponse, { jsonType: UpdateImageTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 116);

/**
 * @generated from message pixel_tracker.v1.DeleteImageTagRequest
 */
export type DeleteImageTagRequest = Message<"pixel_tracker.v1.DeleteImageTagRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.DeleteImageTagRequest
 */
export type DeleteImageTagRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.DeleteImageTagRequest.
 * Use `create(DeleteImageTagRequestSchema)` to create a new message.
 */
export const DeleteImageTagRequestSchema: GenMessage<DeleteImageTagRequest, { jsonType: DeleteImageTagRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 117);

/**
 * @generated from message pixel_tracker.v1.DeleteImageTagResponse
 */
export type DeleteImageTagResponse = Message<"pixel_tracker.v1.DeleteImageTagResponse"> & {};

/**
 * @generated from message pixel_tracker.v1.DeleteImageTagResponse
 */
export type DeleteImageTagResponseJson = {};

/**
 * Describes the message pixel_tracker.v1.DeleteImageTagResponse.
 * Use `create(DeleteImageTagResponseSchema)` to create a new message.
 */
export const DeleteImageTagResponseSchema: GenMessage<DeleteImageTagResponse, { jsonType: DeleteImageTagResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 118);

/**
 * @generated from message pixel_tracker.v1.GenerateImageTagCodeRequest
 */
export type GenerateImageTagCodeRequest = Message<"pixel_tracker.v1.GenerateImageTagCodeRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateImageTagCodeRequest
 */
export type GenerateImageTagCodeRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateImageTagCodeRequest.
 * Use `create(GenerateImageTagCodeRequestSchema)` to create a new message.
 */
export const GenerateImageTagCodeRequestSchema: GenMessage<GenerateImageTagCodeRequest, { jsonType: GenerateImageTagCodeRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 119);

/**
 * @generated from message pixel_tracker.v1.GenerateImageTagCodeResponse
 */
export type GenerateImageTagCodeResponse = Message<"pixel_tracker.v1.GenerateImageTagCodeResponse"> & {
	/**
	 * @generated from field: string code = 1;
	 */
	code: string;
};

/**
 * @generated from message pixel_tracker.v1.GenerateImageTagCodeResponse
 */
export type GenerateImageTagCodeResponseJson = {
	/**
	 * @generated from field: string code = 1;
	 */
	code?: string;
};

/**
 * Describes the message pixel_tracker.v1.GenerateImageTagCodeResponse.
 * Use `create(GenerateImageTagCodeResponseSchema)` to create a new message.
 */
export const GenerateImageTagCodeResponseSchema: GenMessage<GenerateImageTagCodeResponse, { jsonType: GenerateImageTagCodeResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 120);

/**
 * @generated from message pixel_tracker.v1.CollectImagePixelEventRequest
 */
export type CollectImagePixelEventRequest = Message<"pixel_tracker.v1.CollectImagePixelEventRequest"> & {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId: string;

	/**
	 * @generated from field: string fc_pid = 2;
	 */
	fcPid: string;

	/**
	 * @generated from field: string tz = 3;
	 */
	tz: string;

	/**
	 * @generated from field: pixel_tracker.v1.ImagePixelQueryParams query_params = 4;
	 */
	queryParams?: ImagePixelQueryParams;
};

/**
 * @generated from message pixel_tracker.v1.CollectImagePixelEventRequest
 */
export type CollectImagePixelEventRequestJson = {
	/**
	 * @generated from field: string app_id = 1;
	 */
	appId?: string;

	/**
	 * @generated from field: string fc_pid = 2;
	 */
	fcPid?: string;

	/**
	 * @generated from field: string tz = 3;
	 */
	tz?: string;

	/**
	 * @generated from field: pixel_tracker.v1.ImagePixelQueryParams query_params = 4;
	 */
	queryParams?: ImagePixelQueryParamsJson;
};

/**
 * Describes the message pixel_tracker.v1.CollectImagePixelEventRequest.
 * Use `create(CollectImagePixelEventRequestSchema)` to create a new message.
 */
export const CollectImagePixelEventRequestSchema: GenMessage<CollectImagePixelEventRequest, { jsonType: CollectImagePixelEventRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 121);

/**
 * @generated from message pixel_tracker.v1.ImagePixelQueryParams
 */
export type ImagePixelQueryParams = Message<"pixel_tracker.v1.ImagePixelQueryParams"> & {
	/**
	 * @generated from field: map<string, string> values = 1;
	 */
	values: { [key: string]: string };
};

/**
 * @generated from message pixel_tracker.v1.ImagePixelQueryParams
 */
export type ImagePixelQueryParamsJson = {
	/**
	 * @generated from field: map<string, string> values = 1;
	 */
	values?: { [key: string]: string };
};

/**
 * Describes the message pixel_tracker.v1.ImagePixelQueryParams.
 * Use `create(ImagePixelQueryParamsSchema)` to create a new message.
 */
export const ImagePixelQueryParamsSchema: GenMessage<ImagePixelQueryParams, { jsonType: ImagePixelQueryParamsJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 122);

/**
 * @generated from message pixel_tracker.v1.CollectImagePixelEventResponse
 */
export type CollectImagePixelEventResponse = Message<"pixel_tracker.v1.CollectImagePixelEventResponse"> & {
	/**
	 * @generated from field: bytes data = 1;
	 */
	data: Uint8Array;

	/**
	 * @generated from field: string content_type = 2;
	 */
	contentType: string;
};

/**
 * @generated from message pixel_tracker.v1.CollectImagePixelEventResponse
 */
export type CollectImagePixelEventResponseJson = {
	/**
	 * @generated from field: bytes data = 1;
	 */
	data?: string;

	/**
	 * @generated from field: string content_type = 2;
	 */
	contentType?: string;
};

/**
 * Describes the message pixel_tracker.v1.CollectImagePixelEventResponse.
 * Use `create(CollectImagePixelEventResponseSchema)` to create a new message.
 */
export const CollectImagePixelEventResponseSchema: GenMessage<CollectImagePixelEventResponse, { jsonType: CollectImagePixelEventResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 123);

/**
 * @generated from message pixel_tracker.v1.ListContextTemplatesRequest
 */
export type ListContextTemplatesRequest = Message<"pixel_tracker.v1.ListContextTemplatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: repeated string ids = 4;
	 */
	ids: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message pixel_tracker.v1.ListContextTemplatesRequest
 */
export type ListContextTemplatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: repeated string ids = 4;
	 */
	ids?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message pixel_tracker.v1.ListContextTemplatesRequest.
 * Use `create(ListContextTemplatesRequestSchema)` to create a new message.
 */
export const ListContextTemplatesRequestSchema: GenMessage<ListContextTemplatesRequest, { jsonType: ListContextTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 124);

/**
 * @generated from message pixel_tracker.v1.ListContextTemplatesResponse
 */
export type ListContextTemplatesResponse = Message<"pixel_tracker.v1.ListContextTemplatesResponse"> & {
	/**
	 * @generated from field: repeated pixel_tracker.v1.ContextTemplate context_templates = 1;
	 */
	contextTemplates: ContextTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message pixel_tracker.v1.ListContextTemplatesResponse
 */
export type ListContextTemplatesResponseJson = {
	/**
	 * @generated from field: repeated pixel_tracker.v1.ContextTemplate context_templates = 1;
	 */
	contextTemplates?: ContextTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message pixel_tracker.v1.ListContextTemplatesResponse.
 * Use `create(ListContextTemplatesResponseSchema)` to create a new message.
 */
export const ListContextTemplatesResponseSchema: GenMessage<ListContextTemplatesResponse, { jsonType: ListContextTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_pixel_tracker_v1_pixel_tracker, 125);

/**
 * @generated from enum pixel_tracker.v1.FormTrackerEvent
 */
export enum FormTrackerEvent {
	/**
	 * @generated from enum value: FORM_TRACKER_EVENT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: FORM_TRACKER_EVENT_SUBMIT_FORM = 1;
	 */
	SUBMIT_FORM = 1,

	/**
	 * @generated from enum value: FORM_TRACKER_EVENT_CHANGE_FORM = 2;
	 */
	CHANGE_FORM = 2,

	/**
	 * @generated from enum value: FORM_TRACKER_EVENT_FOCUS_FORM = 3;
	 */
	FOCUS_FORM = 3,
}

/**
 * @generated from enum pixel_tracker.v1.FormTrackerEvent
 */
export type FormTrackerEventJson = "FORM_TRACKER_EVENT_UNSPECIFIED" | "FORM_TRACKER_EVENT_SUBMIT_FORM" | "FORM_TRACKER_EVENT_CHANGE_FORM" | "FORM_TRACKER_EVENT_FOCUS_FORM";

/**
 * Describes the enum pixel_tracker.v1.FormTrackerEvent.
 */
export const FormTrackerEventSchema: GenEnum<FormTrackerEvent, FormTrackerEventJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 0);

/**
 * @generated from enum pixel_tracker.v1.TrackerEventType
 */
export enum TrackerEventType {
	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_ACTIVITY = 1;
	 */
	ACTIVITY = 1,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_PAGEVIEW = 2;
	 */
	PAGEVIEW = 2,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_LINK_CLICK = 3;
	 */
	LINK_CLICK = 3,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_BUTTON_CLICK = 4;
	 */
	BUTTON_CLICK = 4,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_FORM = 5;
	 */
	FORM = 5,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_CUSTOM = 6;
	 */
	CUSTOM = 6,

	/**
	 * @generated from enum value: TRACKER_EVENT_TYPE_SHOPIFY = 7;
	 */
	SHOPIFY = 7,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerEventType
 */
export type TrackerEventTypeJson = "TRACKER_EVENT_TYPE_UNSPECIFIED" | "TRACKER_EVENT_TYPE_ACTIVITY" | "TRACKER_EVENT_TYPE_PAGEVIEW" | "TRACKER_EVENT_TYPE_LINK_CLICK" | "TRACKER_EVENT_TYPE_BUTTON_CLICK" | "TRACKER_EVENT_TYPE_FORM" | "TRACKER_EVENT_TYPE_CUSTOM" | "TRACKER_EVENT_TYPE_SHOPIFY";

/**
 * Describes the enum pixel_tracker.v1.TrackerEventType.
 */
export const TrackerEventTypeSchema: GenEnum<TrackerEventType, TrackerEventTypeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 1);

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterElementType
 */
export enum TrackerFilterElementType {
	/**
	 * @generated from enum value: TRACKER_FILTER_ELEMENT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_FILTER_ELEMENT_TYPE_TEXT = 1;
	 */
	TEXT = 1,

	/**
	 * @generated from enum value: TRACKER_FILTER_ELEMENT_TYPE_ID = 2;
	 */
	ID = 2,

	/**
	 * @generated from enum value: TRACKER_FILTER_ELEMENT_TYPE_CLASS = 3;
	 */
	CLASS = 3,

	/**
	 * @generated from enum value: TRACKER_FILTER_ELEMENT_TYPE_NAME = 4;
	 */
	NAME = 4,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterElementType
 */
export type TrackerFilterElementTypeJson = "TRACKER_FILTER_ELEMENT_TYPE_UNSPECIFIED" | "TRACKER_FILTER_ELEMENT_TYPE_TEXT" | "TRACKER_FILTER_ELEMENT_TYPE_ID" | "TRACKER_FILTER_ELEMENT_TYPE_CLASS" | "TRACKER_FILTER_ELEMENT_TYPE_NAME";

/**
 * Describes the enum pixel_tracker.v1.TrackerFilterElementType.
 */
export const TrackerFilterElementTypeSchema: GenEnum<TrackerFilterElementType, TrackerFilterElementTypeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 2);

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterCondition
 */
export enum TrackerFilterCondition {
	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_EQUALS = 1;
	 */
	EQUALS = 1,

	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_STARTS_WITH = 2;
	 */
	STARTS_WITH = 2,

	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_CONTAINS = 3;
	 */
	CONTAINS = 3,

	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_NOT_EQUALS = 4;
	 */
	NOT_EQUALS = 4,

	/**
	 * @generated from enum value: TRACKER_FILTER_CONDITION_NOT_CONTAINS = 5;
	 */
	NOT_CONTAINS = 5,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterCondition
 */
export type TrackerFilterConditionJson = "TRACKER_FILTER_CONDITION_UNSPECIFIED" | "TRACKER_FILTER_CONDITION_EQUALS" | "TRACKER_FILTER_CONDITION_STARTS_WITH" | "TRACKER_FILTER_CONDITION_CONTAINS" | "TRACKER_FILTER_CONDITION_NOT_EQUALS" | "TRACKER_FILTER_CONDITION_NOT_CONTAINS";

/**
 * Describes the enum pixel_tracker.v1.TrackerFilterCondition.
 */
export const TrackerFilterConditionSchema: GenEnum<TrackerFilterCondition, TrackerFilterConditionJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 3);

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterOperator
 */
export enum TrackerFilterOperator {
	/**
	 * @generated from enum value: TRACKER_FILTER_OPERATOR_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_FILTER_OPERATOR_AND = 1;
	 */
	AND = 1,

	/**
	 * @generated from enum value: TRACKER_FILTER_OPERATOR_OR = 2;
	 */
	OR = 2,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerFilterOperator
 */
export type TrackerFilterOperatorJson = "TRACKER_FILTER_OPERATOR_UNSPECIFIED" | "TRACKER_FILTER_OPERATOR_AND" | "TRACKER_FILTER_OPERATOR_OR";

/**
 * Describes the enum pixel_tracker.v1.TrackerFilterOperator.
 */
export const TrackerFilterOperatorSchema: GenEnum<TrackerFilterOperator, TrackerFilterOperatorJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 4);

/**
 * @generated from enum pixel_tracker.v1.PageviewFilterMode
 */
export enum PageviewFilterMode {
	/**
	 * @generated from enum value: PAGEVIEW_FILTER_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PAGEVIEW_FILTER_MODE_INCLUDE = 1;
	 */
	INCLUDE = 1,

	/**
	 * @generated from enum value: PAGEVIEW_FILTER_MODE_EXCLUDE = 2;
	 */
	EXCLUDE = 2,
}

/**
 * @generated from enum pixel_tracker.v1.PageviewFilterMode
 */
export type PageviewFilterModeJson = "PAGEVIEW_FILTER_MODE_UNSPECIFIED" | "PAGEVIEW_FILTER_MODE_INCLUDE" | "PAGEVIEW_FILTER_MODE_EXCLUDE";

/**
 * Describes the enum pixel_tracker.v1.PageviewFilterMode.
 */
export const PageviewFilterModeSchema: GenEnum<PageviewFilterMode, PageviewFilterModeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 5);

/**
 * @generated from enum pixel_tracker.v1.PageviewMatchMode
 */
export enum PageviewMatchMode {
	/**
	 * @generated from enum value: PAGEVIEW_MATCH_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PAGEVIEW_MATCH_MODE_EQUALS = 1;
	 */
	EQUALS = 1,

	/**
	 * @generated from enum value: PAGEVIEW_MATCH_MODE_CONTAINS = 2;
	 */
	CONTAINS = 2,

	/**
	 * @generated from enum value: PAGEVIEW_MATCH_MODE_REGEX = 3;
	 */
	REGEX = 3,
}

/**
 * @generated from enum pixel_tracker.v1.PageviewMatchMode
 */
export type PageviewMatchModeJson = "PAGEVIEW_MATCH_MODE_UNSPECIFIED" | "PAGEVIEW_MATCH_MODE_EQUALS" | "PAGEVIEW_MATCH_MODE_CONTAINS" | "PAGEVIEW_MATCH_MODE_REGEX";

/**
 * Describes the enum pixel_tracker.v1.PageviewMatchMode.
 */
export const PageviewMatchModeSchema: GenEnum<PageviewMatchMode, PageviewMatchModeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 6);

/**
 * @generated from enum pixel_tracker.v1.TrackerContextFieldTag
 */
export enum TrackerContextFieldTag {
	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TAG_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TAG_EMAIL = 1;
	 */
	EMAIL = 1,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TAG_PHONE = 2;
	 */
	PHONE = 2,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerContextFieldTag
 */
export type TrackerContextFieldTagJson = "TRACKER_CONTEXT_FIELD_TAG_UNSPECIFIED" | "TRACKER_CONTEXT_FIELD_TAG_EMAIL" | "TRACKER_CONTEXT_FIELD_TAG_PHONE";

/**
 * Describes the enum pixel_tracker.v1.TrackerContextFieldTag.
 */
export const TrackerContextFieldTagSchema: GenEnum<TrackerContextFieldTag, TrackerContextFieldTagJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 7);

/**
 * @generated from enum pixel_tracker.v1.Platform
 */
export enum Platform {
	/**
	 * @generated from enum value: PLATFORM_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PLATFORM_WEB = 1;
	 */
	WEB = 1,
}

/**
 * @generated from enum pixel_tracker.v1.Platform
 */
export type PlatformJson = "PLATFORM_UNSPECIFIED" | "PLATFORM_WEB";

/**
 * Describes the enum pixel_tracker.v1.Platform.
 */
export const PlatformSchema: GenEnum<Platform, PlatformJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 8);

/**
 * @generated from enum pixel_tracker.v1.CookieSameSite
 */
export enum CookieSameSite {
	/**
	 * @generated from enum value: COOKIE_SAME_SITE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: COOKIE_SAME_SITE_STRICT = 1;
	 */
	STRICT = 1,

	/**
	 * @generated from enum value: COOKIE_SAME_SITE_LAX = 2;
	 */
	LAX = 2,
}

/**
 * @generated from enum pixel_tracker.v1.CookieSameSite
 */
export type CookieSameSiteJson = "COOKIE_SAME_SITE_UNSPECIFIED" | "COOKIE_SAME_SITE_STRICT" | "COOKIE_SAME_SITE_LAX";

/**
 * Describes the enum pixel_tracker.v1.CookieSameSite.
 */
export const CookieSameSiteSchema: GenEnum<CookieSameSite, CookieSameSiteJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 9);

/**
 * @generated from enum pixel_tracker.v1.EventMethod
 */
export enum EventMethod {
	/**
	 * @generated from enum value: EVENT_METHOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EVENT_METHOD_GET = 1;
	 */
	GET = 1,

	/**
	 * @generated from enum value: EVENT_METHOD_POST = 2;
	 */
	POST = 2,

	/**
	 * @generated from enum value: EVENT_METHOD_BEACON = 3;
	 */
	BEACON = 3,
}

/**
 * @generated from enum pixel_tracker.v1.EventMethod
 */
export type EventMethodJson = "EVENT_METHOD_UNSPECIFIED" | "EVENT_METHOD_GET" | "EVENT_METHOD_POST" | "EVENT_METHOD_BEACON";

/**
 * Describes the enum pixel_tracker.v1.EventMethod.
 */
export const EventMethodSchema: GenEnum<EventMethod, EventMethodJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 10);

/**
 * @generated from enum pixel_tracker.v1.StateStorageStrategy
 */
export enum StateStorageStrategy {
	/**
	 * @generated from enum value: STATE_STORAGE_STRATEGY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: STATE_STORAGE_STRATEGY_COOKIE_AND_LOCAL_STORAGE = 1;
	 */
	COOKIE_AND_LOCAL_STORAGE = 1,

	/**
	 * @generated from enum value: STATE_STORAGE_STRATEGY_COOKIE = 2;
	 */
	COOKIE = 2,

	/**
	 * @generated from enum value: STATE_STORAGE_STRATEGY_LOCAL_STORAGE = 3;
	 */
	LOCAL_STORAGE = 3,
}

/**
 * @generated from enum pixel_tracker.v1.StateStorageStrategy
 */
export type StateStorageStrategyJson = "STATE_STORAGE_STRATEGY_UNSPECIFIED" | "STATE_STORAGE_STRATEGY_COOKIE_AND_LOCAL_STORAGE" | "STATE_STORAGE_STRATEGY_COOKIE" | "STATE_STORAGE_STRATEGY_LOCAL_STORAGE";

/**
 * Describes the enum pixel_tracker.v1.StateStorageStrategy.
 */
export const StateStorageStrategySchema: GenEnum<StateStorageStrategy, StateStorageStrategyJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 11);

/**
 * @generated from enum pixel_tracker.v1.PreservePageViewIdForUrl
 */
export enum PreservePageViewIdForUrl {
	/**
	 * @generated from enum value: PRESERVE_PAGE_VIEW_ID_FOR_URL_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PRESERVE_PAGE_VIEW_ID_FOR_URL_FALSE = 1;
	 */
	FALSE = 1,

	/**
	 * @generated from enum value: PRESERVE_PAGE_VIEW_ID_FOR_URL_TRUE = 2;
	 */
	TRUE = 2,

	/**
	 * @generated from enum value: PRESERVE_PAGE_VIEW_ID_FOR_URL_PATH_NAME = 3;
	 */
	PATH_NAME = 3,

	/**
	 * @generated from enum value: PRESERVE_PAGE_VIEW_ID_FOR_URL_PATH_NAME_AND_SEARCH = 4;
	 */
	PATH_NAME_AND_SEARCH = 4,
}

/**
 * @generated from enum pixel_tracker.v1.PreservePageViewIdForUrl
 */
export type PreservePageViewIdForUrlJson = "PRESERVE_PAGE_VIEW_ID_FOR_URL_UNSPECIFIED" | "PRESERVE_PAGE_VIEW_ID_FOR_URL_FALSE" | "PRESERVE_PAGE_VIEW_ID_FOR_URL_TRUE" | "PRESERVE_PAGE_VIEW_ID_FOR_URL_PATH_NAME" | "PRESERVE_PAGE_VIEW_ID_FOR_URL_PATH_NAME_AND_SEARCH";

/**
 * Describes the enum pixel_tracker.v1.PreservePageViewIdForUrl.
 */
export const PreservePageViewIdForUrlSchema: GenEnum<PreservePageViewIdForUrl, PreservePageViewIdForUrlJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 12);

/**
 * @generated from enum pixel_tracker.v1.TrackerContextFieldType
 */
export enum TrackerContextFieldType {
	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_TEXT = 1;
	 */
	TEXT = 1,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_INT = 7;
	 */
	INT = 7,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_NUMBER = 2;
	 */
	NUMBER = 2,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_OBJECT = 3;
	 */
	OBJECT = 3,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_ARRAY_TEXT = 4;
	 */
	ARRAY_TEXT = 4,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_ARRAY_NUMBER = 5;
	 */
	ARRAY_NUMBER = 5,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_ARRAY_INT = 8;
	 */
	ARRAY_INT = 8,

	/**
	 * @generated from enum value: TRACKER_CONTEXT_FIELD_TYPE_ARRAY_OBJECT = 6;
	 */
	ARRAY_OBJECT = 6,
}

/**
 * @generated from enum pixel_tracker.v1.TrackerContextFieldType
 */
export type TrackerContextFieldTypeJson =
	"TRACKER_CONTEXT_FIELD_TYPE_UNSPECIFIED" | "TRACKER_CONTEXT_FIELD_TYPE_TEXT" | "TRACKER_CONTEXT_FIELD_TYPE_INT" | "TRACKER_CONTEXT_FIELD_TYPE_NUMBER" | "TRACKER_CONTEXT_FIELD_TYPE_OBJECT" | "TRACKER_CONTEXT_FIELD_TYPE_ARRAY_TEXT" | "TRACKER_CONTEXT_FIELD_TYPE_ARRAY_NUMBER" | "TRACKER_CONTEXT_FIELD_TYPE_ARRAY_INT" | "TRACKER_CONTEXT_FIELD_TYPE_ARRAY_OBJECT";

/**
 * Describes the enum pixel_tracker.v1.TrackerContextFieldType.
 */
export const TrackerContextFieldTypeSchema: GenEnum<TrackerContextFieldType, TrackerContextFieldTypeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 13);

/**
 * @generated from enum pixel_tracker.v1.SemanticVersionChangeType
 */
export enum SemanticVersionChangeType {
	/**
	 * @generated from enum value: SEMANTIC_VERSION_CHANGE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SEMANTIC_VERSION_CHANGE_TYPE_MAJOR = 1;
	 */
	MAJOR = 1,

	/**
	 * @generated from enum value: SEMANTIC_VERSION_CHANGE_TYPE_MINOR = 2;
	 */
	MINOR = 2,

	/**
	 * @generated from enum value: SEMANTIC_VERSION_CHANGE_TYPE_REVISION = 3;
	 */
	REVISION = 3,
}

/**
 * @generated from enum pixel_tracker.v1.SemanticVersionChangeType
 */
export type SemanticVersionChangeTypeJson = "SEMANTIC_VERSION_CHANGE_TYPE_UNSPECIFIED" | "SEMANTIC_VERSION_CHANGE_TYPE_MAJOR" | "SEMANTIC_VERSION_CHANGE_TYPE_MINOR" | "SEMANTIC_VERSION_CHANGE_TYPE_REVISION";

/**
 * Describes the enum pixel_tracker.v1.SemanticVersionChangeType.
 */
export const SemanticVersionChangeTypeSchema: GenEnum<SemanticVersionChangeType, SemanticVersionChangeTypeJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 14);

/**
 * @generated from enum pixel_tracker.v1.OrderMappingFields
 */
export enum OrderMappingFields {
	/**
	 * @generated from enum value: ORDER_MAPPING_FIELDS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ORDER_MAPPING_FIELDS_CURRENCY_CODE = 1;
	 */
	CURRENCY_CODE = 1,

	/**
	 * @generated from enum value: ORDER_MAPPING_FIELDS_ORDER_NUMBER = 2;
	 */
	ORDER_NUMBER = 2,

	/**
	 * @generated from enum value: ORDER_MAPPING_FIELDS_COST = 3;
	 */
	COST = 3,

	/**
	 * @generated from enum value: ORDER_MAPPING_FIELDS_QUANTITY = 4;
	 */
	QUANTITY = 4,
}

/**
 * @generated from enum pixel_tracker.v1.OrderMappingFields
 */
export type OrderMappingFieldsJson = "ORDER_MAPPING_FIELDS_UNSPECIFIED" | "ORDER_MAPPING_FIELDS_CURRENCY_CODE" | "ORDER_MAPPING_FIELDS_ORDER_NUMBER" | "ORDER_MAPPING_FIELDS_COST" | "ORDER_MAPPING_FIELDS_QUANTITY";

/**
 * Describes the enum pixel_tracker.v1.OrderMappingFields.
 */
export const OrderMappingFieldsSchema: GenEnum<OrderMappingFields, OrderMappingFieldsJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 15);

/**
 * @generated from enum pixel_tracker.v1.IdentityMappingFields
 */
export enum IdentityMappingFields {
	/**
	 * @generated from enum value: IDENTITY_MAPPING_FIELDS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: IDENTITY_MAPPING_FIELDS_EMAIL = 1;
	 */
	EMAIL = 1,

	/**
	 * @generated from enum value: IDENTITY_MAPPING_FIELDS_FIRSTNAME = 2;
	 */
	FIRSTNAME = 2,

	/**
	 * @generated from enum value: IDENTITY_MAPPING_FIELDS_LASTNAME = 3;
	 */
	LASTNAME = 3,

	/**
	 * @generated from enum value: IDENTITY_MAPPING_FIELDS_PHONE = 4;
	 */
	PHONE = 4,
}

/**
 * @generated from enum pixel_tracker.v1.IdentityMappingFields
 */
export type IdentityMappingFieldsJson = "IDENTITY_MAPPING_FIELDS_UNSPECIFIED" | "IDENTITY_MAPPING_FIELDS_EMAIL" | "IDENTITY_MAPPING_FIELDS_FIRSTNAME" | "IDENTITY_MAPPING_FIELDS_LASTNAME" | "IDENTITY_MAPPING_FIELDS_PHONE";

/**
 * Describes the enum pixel_tracker.v1.IdentityMappingFields.
 */
export const IdentityMappingFieldsSchema: GenEnum<IdentityMappingFields, IdentityMappingFieldsJson> = /*@__PURE__*/ enumDesc(file_pixel_tracker_v1_pixel_tracker, 16);

/**
 * @generated from service pixel_tracker.v1.PixelTrackerService
 */
export const PixelTrackerService: GenService<{
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateTag
	 */
	createTag: {
		methodKind: "unary";
		input: typeof CreateTagRequestSchema;
		output: typeof CreateTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetTag
	 */
	getTag: {
		methodKind: "unary";
		input: typeof GetTagRequestSchema;
		output: typeof GetTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GenerateStaticTagCode
	 */
	generateStaticTagCode: {
		methodKind: "unary";
		input: typeof GenerateStaticTagCodeRequestSchema;
		output: typeof GenerateStaticTagCodeResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GenerateInlineTrackerFunctions
	 */
	generateInlineTrackerFunctions: {
		methodKind: "unary";
		input: typeof GenerateInlineTrackerFunctionsRequestSchema;
		output: typeof GenerateInlineTrackerFunctionsResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GenerateInlineTrackerFunctionMap
	 */
	generateInlineTrackerFunctionMap: {
		methodKind: "unary";
		input: typeof GenerateInlineTrackerFunctionMapRequestSchema;
		output: typeof GenerateInlineTrackerFunctionMapResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateTag
	 */
	updateTag: {
		methodKind: "unary";
		input: typeof UpdateTagRequestSchema;
		output: typeof UpdateTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.ListTags
	 */
	listTags: {
		methodKind: "unary";
		input: typeof ListTagsRequestSchema;
		output: typeof ListTagsResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.ListWorkspaceTags
	 */
	listWorkspaceTags: {
		methodKind: "unary";
		input: typeof ListWorkspaceTagsRequestSchema;
		output: typeof ListWorkspaceTagsResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteTag
	 */
	deleteTag: {
		methodKind: "unary";
		input: typeof DeleteTagRequestSchema;
		output: typeof DeleteTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateTracker
	 */
	createTracker: {
		methodKind: "unary";
		input: typeof CreateTrackerRequestSchema;
		output: typeof CreateTrackerResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateTracker
	 */
	updateTracker: {
		methodKind: "unary";
		input: typeof UpdateTrackerRequestSchema;
		output: typeof UpdateTrackerResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteTracker
	 */
	deleteTracker: {
		methodKind: "unary";
		input: typeof DeleteTrackerRequestSchema;
		output: typeof DeleteTrackerResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateSuiteOverride
	 */
	createSuiteOverride: {
		methodKind: "unary";
		input: typeof CreateSuiteOverrideRequestSchema;
		output: typeof CreateSuiteOverrideResponseSchema;
	};
	/**
	 * option (common.v1.authentication) = {policy: POLICY_REQUIRED};
	 *
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetSuiteOverride
	 */
	getSuiteOverride: {
		methodKind: "unary";
		input: typeof GetSuiteOverrideRequestSchema;
		output: typeof GetSuiteOverrideResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetTrackerByTagAndSuiteId
	 */
	getTrackerByTagAndSuiteId: {
		methodKind: "unary";
		input: typeof GetTrackerByTagAndSuiteIdRequestSchema;
		output: typeof GetTrackerByTagAndSuiteIdResponseSchema;
	};
	/**
	 * option (common.v1.authentication) = {policy: POLICY_REQUIRED};
	 *
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetSuiteOverrideByTagAndSuiteId
	 */
	getSuiteOverrideByTagAndSuiteId: {
		methodKind: "unary";
		input: typeof GetSuiteOverrideByTagAndSuiteIdRequestSchema;
		output: typeof GetSuiteOverrideByTagAndSuiteIdResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateSuiteOverride
	 */
	updateSuiteOverride: {
		methodKind: "unary";
		input: typeof UpdateSuiteOverrideRequestSchema;
		output: typeof UpdateSuiteOverrideResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteSuiteOverride
	 */
	deleteSuiteOverride: {
		methodKind: "unary";
		input: typeof DeleteSuiteOverrideRequestSchema;
		output: typeof DeleteSuiteOverrideResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GenerateTagCode
	 */
	generateTagCode: {
		methodKind: "unary";
		input: typeof GenerateTagCodeRequestSchema;
		output: typeof GenerateTagCodeResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GeneratePixelCode
	 */
	generatePixelCode: {
		methodKind: "unary";
		input: typeof GeneratePixelCodeRequestSchema;
		output: typeof GeneratePixelCodeResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateImageTag
	 */
	createImageTag: {
		methodKind: "unary";
		input: typeof CreateImageTagRequestSchema;
		output: typeof CreateImageTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetImageTag
	 */
	getImageTag: {
		methodKind: "unary";
		input: typeof GetImageTagRequestSchema;
		output: typeof GetImageTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateImageTag
	 */
	updateImageTag: {
		methodKind: "unary";
		input: typeof UpdateImageTagRequestSchema;
		output: typeof UpdateImageTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteImageTag
	 */
	deleteImageTag: {
		methodKind: "unary";
		input: typeof DeleteImageTagRequestSchema;
		output: typeof DeleteImageTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GenerateImageTagCode
	 */
	generateImageTagCode: {
		methodKind: "unary";
		input: typeof GenerateImageTagCodeRequestSchema;
		output: typeof GenerateImageTagCodeResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetAllDomains
	 */
	getAllDomains: {
		methodKind: "unary";
		input: typeof GetAllDomainsRequestSchema;
		output: typeof GetAllDomainsResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateContextTemplate
	 */
	createContextTemplate: {
		methodKind: "unary";
		input: typeof CreateContextTemplateRequestSchema;
		output: typeof CreateContextTemplateResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetContextTemplate
	 */
	getContextTemplate: {
		methodKind: "unary";
		input: typeof GetContextTemplateRequestSchema;
		output: typeof GetContextTemplateResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.ListContextTemplates
	 */
	listContextTemplates: {
		methodKind: "unary";
		input: typeof ListContextTemplatesRequestSchema;
		output: typeof ListContextTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateContextTemplate
	 */
	updateContextTemplate: {
		methodKind: "unary";
		input: typeof UpdateContextTemplateRequestSchema;
		output: typeof UpdateContextTemplateResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteContextTemplate
	 */
	deleteContextTemplate: {
		methodKind: "unary";
		input: typeof DeleteContextTemplateRequestSchema;
		output: typeof DeleteContextTemplateResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateJsonSchema
	 */
	createJsonSchema: {
		methodKind: "unary";
		input: typeof CreateJsonSchemaRequestSchema;
		output: typeof CreateJsonSchemaResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.CreateJsonSchemaVersion
	 */
	createJsonSchemaVersion: {
		methodKind: "unary";
		input: typeof CreateJsonSchemaVersionRequestSchema;
		output: typeof CreateJsonSchemaVersionResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.GetJsonSchema
	 */
	getJsonSchema: {
		methodKind: "unary";
		input: typeof GetJsonSchemaRequestSchema;
		output: typeof GetJsonSchemaResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.UpdateJsonSchema
	 */
	updateJsonSchema: {
		methodKind: "unary";
		input: typeof UpdateJsonSchemaRequestSchema;
		output: typeof UpdateJsonSchemaResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerService.DeleteJsonSchema
	 */
	deleteJsonSchema: {
		methodKind: "unary";
		input: typeof DeleteJsonSchemaRequestSchema;
		output: typeof DeleteJsonSchemaResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_pixel_tracker_v1_pixel_tracker, 0);

/**
 * @generated from service pixel_tracker.v1.PixelTrackerInternalService
 */
export const PixelTrackerInternalService: GenService<{
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerInternalService.GetTagByAppId
	 */
	getTagByAppId: {
		methodKind: "unary";
		input: typeof GetTagByAppIdRequestSchema;
		output: typeof GetTagByAppIdResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerInternalService.GetImageTagByAppId
	 */
	getImageTagByAppId: {
		methodKind: "unary";
		input: typeof GetImageTagByAppIdRequestSchema;
		output: typeof GetImageTagByAppIdResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerInternalService.GetSuiteTag
	 */
	getSuiteTag: {
		methodKind: "unary";
		input: typeof GetSuiteTagRequestSchema;
		output: typeof GetSuiteTagResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelTrackerInternalService.ValidateCustomPayload
	 */
	validateCustomPayload: {
		methodKind: "unary";
		input: typeof ValidateCustomPayloadRequestSchema;
		output: typeof ValidateCustomPayloadResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_pixel_tracker_v1_pixel_tracker, 1);

/**
 * @generated from service pixel_tracker.v1.PixelCollectorService
 */
export const PixelCollectorService: GenService<{
	/**
	 * @generated from rpc pixel_tracker.v1.PixelCollectorService.CollectPixelEvent
	 */
	collectPixelEvent: {
		methodKind: "unary";
		input: typeof CollectPixelEventRequestSchema;
		output: typeof CollectPixelEventResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelCollectorService.CollectServerPixelEvent
	 */
	collectServerPixelEvent: {
		methodKind: "unary";
		input: typeof CollectServerPixelEventRequestSchema;
		output: typeof CollectServerPixelEventResponseSchema;
	};
	/**
	 * @generated from rpc pixel_tracker.v1.PixelCollectorService.CollectImagePixelEvent
	 */
	collectImagePixelEvent: {
		methodKind: "unary";
		input: typeof CollectImagePixelEventRequestSchema;
		output: typeof CollectImagePixelEventResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_pixel_tracker_v1_pixel_tracker, 2);
